import { IObservableValue, observable } from "mobx";

import { MAX_PROMOCODE_REWARD_IN_HOURS } from "./input-entries-constants";

export type Ti18nKeys =
  | "CHOOSE"
  | "ENVIRONMENT"
  | "DEPLOYED"
  | "ALKHATTABA_ADMIN"
  | "MAIN_NAVIGATION"
  | "ET3ARRAF"
  | "USERNAME"
  | "PASSWORD"
  | "SIGN_IN"
  | "ERROR_MESSAGE"
  | "LIMIT"
  | "DATE_MIN"
  | "DATE_MAX"
  | "PLATFORM"
  | "STATUS"
  | "COUNTRY_CREATED_FROM"
  | "TYPE"
  | "COUNTRY"
  | "SENDER_ID"
  | "RECEIVER_ID"
  | "ADMIN"
  | "USER"
  | "MONITOR_USER_MESSAGES"
  | "USER_MESSAGES_TABLE"
  | "USER_ID"
  | "TRANSACTION_ID"
  | "DEVICE_ID"
  | "VIP_DAYS"
  | "VIP_HOURS"
  | "SEARCH_BY"
  | "GET"
  | "VIEW_CONVERSATION"
  | "GET_RESULTS"
  | "EVENTS_LIST"
  | "EVENTS_COUNT"
  | "SEARCH_BY_USER_ID"
  | "SEARCH_BY_TRANSACTION_ID"
  | "ONLY_FOR_SE"
  | "CHANGE_STATUS"
  | "CHANGE_USERNAME"
  | "MAKE_VIP"
  | "FLAG"
  | "RESET_ACCOUNT"
  | "CLEAN_POOL"
  | "PICTURE"
  | "DESCRIPTION"
  | "NO_DESCRIPTION"
  | "APPROVE"
  | "REJECT"
  | "APPROVED"
  | "REJECTED"
  | "REJECT_PICTURE"
  | "REJECT_DESCRIPTION"
  | "OLD_PASSWORD"
  | "NEW_PASSWORD"
  | "CONFIRM_PASSWORD"
  | "CHANGE_ROLE"
  | "CHANGE_PASSWORD"
  | "RESOLVE"
  | "WARN"
  | "EMAIL"
  | "BAN"
  | "TEMPORARY_BAN"
  | "SEARCH"
  | "SEARCH_NO_RESULT"
  | "SEARCH_SENSITIVE_CASE"
  | "UPDATED_ON"
  | "REPORTS"
  | "REPORTS_USER_TO_USER"
  | "DASHBOARD"
  | "CONTROL_PANEL"
  | "CONVERSATION"
  | "BETWEEN_TWO_USERS"
  | "OH_ITS_ME"
  | "OH_NO"
  | "WARNING"
  | "SUCCESS"
  | "APPROVAL"
  | "APPROVE_USER_DATA"
  | "MONITOR_USER_PAYMENTS"
  | "MONITOR_USER_LOGIN"
  | "USER_LOGIN_TABLE"
  | "USER_ACTION_BUTTONS"
  | "MONITOR_USER_EVENTS"
  | "ADVANCED_MODE"
  | "INFO_ABOUT_USER_ACTIVITIES"
  | "GET_SIDED_STATISTICS"
  | "VIEW_EDIT_ADMIN_POOL"
  | "POOL_TABLE"
  | "VIEW_EDIT_ADMIN_PERMISSION"
  | "INVESTIGATION_CASES"
  | "ADMIN_EVENTS"
  | "VIEW_ADMIN_EVENTS"
  | "VIEW_ADMIN_EVENTS_CHARTS"
  | "VIEW_ADMIN_AUDITED_EVENTS"
  | "NO_RECEIPT_TOKEN_FOUND"
  | "COPYRIGHT"
  | "ET3ARRAF_SAL"
  | "ALL_RIGHTS_RESERVED"
  | "VERSION"
  | "APPROVE_REJECT_DATA"
  | "USER_MESSAGES"
  | "USER_PAYMENTS"
  | "USER_EVENTS"
  | "COMMUNITY"
  | "ENGAGMENT"
  | "FINANCIALS"
  | "USER_LOCATION_CHART_TITLE"
  | "USER_GENDER_CHART_TITLE"
  | "GCC_COUNTRIES"
  | "LEVANT_COUNTRIES"
  | "NA_COUNTRIES"
  | "OTHER_COUNTRIES"
  | "TOTAL_CONVERSATIONS_CHART_TITLE"
  | "TOTAL_MONTHLY_CONVERSATIONS_CHART_TITLE"
  | "TWO_SIDED_CONVERSATION_RATIO"
  | "TOTAL_USERS_NUMBERS"
  | "TOTAL_MONTHLY_NEW_USERS"
  | "EXPENSES_PER_MONTH"
  | "APPROVE_REJECT"
  | "LAST_LOGIN"
  | "SIGN_OUT"
  | "REASON"
  | "COMMENT"
  | "REPORTER"
  | "REPORTED"
  | "REFRESH"
  | "REPORT_REASON_1"
  | "REPORT_REASON_2"
  | "REPORT_REASON_3"
  | "REPORT_REASON_4"
  | "REPORT_REASON_5"
  | "PAID"
  | "NOT_PAID"
  | "INVALID_CREDENTIALS"
  | "INCORRECT_NEWPASSWORD"
  | "INCORRECT_OLD_PASSWORD"
  | "SERVER_ENCOUNTERED_ERROR"
  | "PASSWORD_CHANGE_SUCCESSFUL"
  | "WRONG_INPUT"
  | "LOADING"
  | "ACCEPT"
  | "ACCEPT_DESCRIPTION"
  | "ACCEPT_PICTURE"
  | "USER_STATUS_CHANGED_SUCCESSFULLY"
  | "USER_NAME_CHANGED_SUCCESSFULLY"
  | "USER_VIP_ADDED_SUCCESSFULLY"
  | "USER_FLAGGED_SUCCESSFULLY"
  | "USER_GENDER_CHANGED_SUCCESSFULLY"
  | "DESCRIPTION_REJECTED_SUCCESSFULLY"
  | "PEER_DESCRIPTION_REJECTED_SUCCESSFULLY"
  | "DESCRIPTION_APPROVED_SUCCESSFULLY"
  | "PEER_DESCRIPTION_APPROVED_SUCCESSFULLY"
  | "PICTURE_REJECTED_SUCCESSFULLY"
  | "PICTURE_APPROVED_SUCCESSFULLY"
  | "ORDER"
  | "USER_EVENTS_TABLE"
  | "USER_DEVICES_TABLE"
  | "DEVICE_UNLINKED_SUCCESSFULLY"
  | "MESSAGES_SEND_FROM"
  | "FROM"
  | "TO"
  | "ACTION_TAKEN"
  | "TBW"
  | "TBW_REASONS"
  | "SELECT_REASONS_OF_ACTION"
  | "ACTIVE"
  | "WRONG_AND_FIX"
  | "CORRECT"
  | "WRONG"
  | "INCORRECT_VIP_DAYS_HOURS"
  | "SELECT_SMALLER_DATE_RANGE"
  | "SELECT_CORRECT_DATE_RANGE"
  | "CHECK_START_EXPIRY_DATE"
  | "GENDER"
  | "USER_ADVANCED_TABLE"
  | "USER_ADVANCED_QUIZ_TABLE"
  | "USER_ADVANCED_EMAIL_TABLE"
  | "VIEW_EDIT_ADMIN_DASHBOARD"
  | "MINOR_ISSUE"
  | "MAJOR_ISSUE"
  | "NO_ISSUE"
  | "USER_WARNED"
  | "REPORT_RESOLVE"
  | "REPORT_EMAIL"
  | "USER_BANNED"
  | "USER_TEMPORARY_BANNED"
  | "AUDIT_PERFORMANCE"
  | "IMAGE_DELETED"
  | "MARK_SEEN"
  | "AUDIT_EFFICIENCY"
  | "Admin_Audit_Helper_Text"
  | "Admin_Audit_Events_Helper_Text"
  | "Supervise_Helper_Text"
  | "Supervise_Events_Helper_Text"
  | "MONITOR_USER_MESSAGE_ID"
  | "MESSAGE_ID"
  | "USER_MESSAGES_ID_TABLE"
  | "WRONG_MESSAGE_ID"
  | "WORKLOAD_DATA_BETWEEN_TWO_DATES"
  | "WORKLOAD_TABLE"
  | "AUDITING_PERFORMANCE"
  | "AUDITING_PERFORMANCE_DASHBOARD"
  | "DATE_RANGE"
  | "USER_EDIT_PROFILE"
  | "USER_EDIT_PROFILE_ARCHIVE"
  | "EDIT_USER_DATA"
  | "INVALID_PASSWORD"
  | "INCORRECT_PASSWORD_REPEATED"
  | "USER_REFERRAL_CODE_USAGE_TABLE"
  | "WRONG_USER_ID"
  | "USER_DATA_CHANGED"
  | "USER_BANNED_SUCCESSFULLY"
  | "USER_WARNED_SUCCESSFULLY"
  | "POOL_CLEANED"
  | "USER_LATEST_RECEIPT"
  | "LOAD_MORE"
  | "TESTER"
  | "OPTIONS"
  | "ADD_TBW"
  | "ISSUE_TYPE"
  | "PAYMENT_PACKAGES_TODAY"
  | "PAYMENT_PACKAGES_PREV_DAY"
  | "PACKAGE_NOTIFICATION_TYPE_COUNT"
  | "COPY"
  | "STATS_DASHBOARD"
  | "PERFORMANCE"
  | "EFFECTIVENESS"
  | "REFRESH"
  | "USER_EMAIL_EVENTS_TABLE"
  | "USER_DEACTIVATIONS_TABLE"
  | "IOS_PAYMENTS"
  | "ANDROID_PAYMENTS"
  | "LAST_LOGIN_USERS"
  | "EMAIL_USERS"
  | "SENT_EMAILS"
  | "SMS_USERS"
  | "FB_USERS"
  | "NEW_USERS"
  | "TIME_FRAME"
  | "DAILY_STATS"
  | "REPORT_POOL_TABLE"
  | "APPROVAL_POOL_TABLE"
  | "INVESTIGATION_CASES_POOL_TABLE"
  | "UNLINK_DEVICE"
  | "INVESTIGATE"
  | "ALREADY_EXISTING_VALUE"
  | "SORRY_NO_PERMISSION"
  | "SAVE"
  | "EDIT"
  | "DELETE"
  | "HELPER"
  | "EMPTY_STRING"
  | "PAYMENT_DATA_HELPER"
  | "USER_NAME_CONDITIONS"
  | "SAME_USER_NAME"
  | "EVENTS_NOT_FOUND"
  | "SESSION_EXPIRED"
  | "WELCOME"
  | "USER_RATE_US_DATA_NOT_FOUND"
  | "USER_RESET_SUCCESSFULLY"
  | "DANGER_TO_PRESS"
  | "PASSCODE"
  | "ERROR"
  | "OK"
  | "ET3ERROR"
  | "ROUTE_NOT_DEFINED"
  | "INVALID_MISSING_ID_TYPE_NUMBER"
  | "INVALID_PASSWORD_NUM"
  | "INVALID_USER_ID"
  | "INVALID_PLATFORM"
  | "INVALID_CREDENTIALS_NUM"
  | "INVALID_INPUT"
  | "INVALID_EVENT_TYPE"
  | "INVALID_STATUS"
  | "INVALID_TIME_FRAME"
  | "INVALID_COUNTRY"
  | "APPROVAL_DATA_NOT_FOUND"
  | "REPORTS_NOT_FOUND"
  | "ACTIVITIES_NOT_FOUND"
  | "NO_RESULT"
  | "SERVER_ERROR_SHOWING_CONTACT"
  | "USER_NOT_FOUND"
  | "ADMIN_ID_REQUIRED"
  | "ADMIN_NOT_FOUND"
  | "NO_PERMISSION"
  | "DEVICE_NOT_FOUND"
  | "USER_LOGIN_NOT_FOUND"
  | "PAYMENTS_NOT_FOUND"
  | "TRANSACTION_NOT_FOUND"
  | "MESSAGES_NOT_FOUND"
  | "CONVERSATION_NOT_FOUND"
  | "INCORRECT_PASSWORD"
  | "NO_APPROVAL_DATA"
  | "SOMETHING_WRONG"
  | "CANNOT_CHANGE_STATUS_TO_ACTIVE"
  | "POOL_ALREADY_EMPTY"
  | "WRONGKEY"
  | "WRONGBODYCOUNT"
  | "REFERRAL_CODE_NOT_FOUND"
  | "USER_HAS_NO_REFERRAL_CODE"
  | "INVALID_TOKEN"
  | "INVALID_USER_NAME"
  | "PLEASE_SHARE_FACEBOOK"
  | "PLEASE_SHARE_NUMBER"
  | "PLEASE_SHARE_DATA_TABLE"
  | "PLEASE_SHARE_USERS_TABLE"
  | "PLEASE_SHARE_APPLE_ID"
  | "WATCH_ALERT_DASHBOARD"
  | "USERS"
  | "USERS_LOGIN"
  | "USERS_PAYMENTS"
  | "ADVANCED"
  | "CONVERSATIONS"
  | "EVENTS"
  | "MESSAGES"
  | "PAYMENTS"
  | "PERMISSION"
  | "RESET_PASSWORD"
  | "RESET_ADMIN_PASSWORDS"
  | "NEW_GENERATED_PASSWORD"
  | "ALARMS"
  | "PROMO_CODE_DESCRIPTION"
  | "PROMO_CODE_REWARD_IN_HOURS"
  | "PROMO_CODE_NATIONALITY"
  | "PROMO_CODE_VIP_MAX_USAGE"
  | "PROMO_CODE_ACTIVE"
  | "PROMO_CODE_START_DATE"
  | "PROMO_CODE_EXPIRY_DATE"
  | "GENERATE"
  | "PROMO_CODE_GENERATED_SUCCESSFULLY"
  | "PROMO_CODES"
  | "PROMO_CODE_ID"
  | "USER_PROMO_CODE_USAGE_TABLE"
  | "ALL_PROMO_CODES"
  | "UPDATE_PROMO_CODE"
  | "PROMO_CODE_PAID"
  | "PROMO_CODE_UPDATED_SUCCESSFULLY"
  | "PROMO_CODE_IS_NO_UPDATED"
  | "FLAGGED_CONNECTION_ADMIN"
  | "FLAGGED_CONNECTION_WEB"
  | "FLAGGED_CONNECTION_APP"
  | "FLAGGED_CONNECTION"
  | "USER_ID_PICTURE_REJECT"
  | "VIP_DETAILS"
  | "RATE_LIMIT"
  | "ON_ALERT"
  | "EMPTY_TBW_REASONS_DATA"
  | "PROMOCODE_REWARD_IN_HOURS"
  | "PROMOCODE_NOT_SUPPORTED_FOR_GENDER"
  | "PROMO_STATUS_NOT_UPDATED_SUCCESSFULLY"
  | "FLUSH_HOST_ALERT"
  | "USER_ALBUM_PICTURES"
  | "USERS_DATA"
  | "USERS_PURCHASES_AND_SUBSCRIPTIONS"
  | "USER_BREACHES_TABLE"
  | "TB_DEACTIVATED_USER"
  | "EMAIL_SENT"
  | "USER_NAME"
  | "NATIONALITY"
  | "COUNTRY_OF_RESIDENCE"
  | "CITY_OF_RESIDENCE"
  | "AGE"
  | "HEIGHT"
  | "WEIGHT"
  | "USER_SEARCH_TYPE_REQUIRED"
  | "USER_ALL_COMMENTS"
  | "ADD_COMMENTS_POPUP_TEXT"
  | "ADD_RESET_ACCOUNT_POPUP_TEXT"
  | "ADD_COMMENT"
  | "EMPTY_COMMENT"
  | "UNDER_CSR_INVESTIGATION_STATUS"
  | "INVESTIGATION_CASES_NOT_FOUND"
  | "DESCRIPTION_ABOUT_ME"
  | "DESCRIPTION_ABOUT_MY_PARTNER"
  | "VIEW_ACCOUNTS_DELETION_DATA"
  | "ACCOUNT_DELETION_HELPER_TEXT"
  | "ACCOUNTS_DELETION_DATA"
  | "FOUND_PARTNER_OUTSIDE_ET3ARRAF"
  | "NOT_AS_EXPECTED"
  | "OTHER_REASONS"
  | "ER3ARRAF_IS_HARD_TO_USE"
  | "NOT_ABLE_TO_FIND_PARTNER"
  | "FOUND_PARTNER_THROUGH_ET3ARRAF"
  | "ACCOUNTS_DELETION_DATA_NOT_FOUND"
  | "USER_ALREADY_UNDER_CSR_INVESTIGATION"
  | "REPORT_NOT_FOUND"
  | "TURN_OFF_FEATURES"
  | "FEATURES"
  | "KHATTABAT_CAPACITY"
  | "FEATURE_OFF"
  | "FEATURE_ON"
  | "ALARMS_NOT_FOUND"
  | "USER_STATUS_DATE"
  | "USER_EMAIL_SUBSCRIPTION"
  | "USER_STATUS"
  | "QA_CHANGE_STATUS_DATE"
  | "SUBSCRIBE"
  | "UNSUBSCRIBE"
  | "QA_NEW_STATUS_DATE"
  | "UPDATING_TO_VERSION"
  | "EXPORT_TO_CSV_FILE"
  | "PEER_DESCRIPTION_ACTION_ALREADY_DONE"
  | "PICTURE_ACTION_ALREADY_DONE"
  | "DESCRIPTION_ACTION_ALREADY_DONE"
  | "MESSAGE_TYPE"
  | "LIMIT_BY_REPORTED"
  | "PROMO_CODE_KEY"
  | "INVALID_PROMO_CODE_KEY"
  | "PROMO_CODE_ALREADY_EXISTS"
  | "VIP_MIN"
  | "AUDIT_EVENTS_POOL_TABLE"
  | "IOS_RECEIPT_TOKEN_DATA"
  | "SAFE"
  | "RATE_LIMIT_MOBILE_APP"
  | "RATE_LIMIT_WEBSITE"
  | "RATE_LIMIT_ADMIN"
  | "IP_GEOLOCATION"
  | "ALERT"
  | "DANGER"
  | "GO_TO_USER_ADVANCED"
  | "GO_TO_MESSAGES"
  | "DESCRIPTION_CHANGED"
  | "INVESTIGATION_CASE_ALREADY_RESOLVED"
  | "INVESTIGATION_CASE_EXITS_IN_SOME_POOL"
  | "REPORT_CASE_EXISTS_IN_SOME_POOL"
  | "REPORT_CASES_ALREADY_RESOLVED"
  | "USER_SHOULD_BE_VERIFIED"
  | "SOCIAL_MEDIA_ACCOUNT"
  | "BAD_WORDS"
  | "GET_USER_BANNED"
  | "FLAGGED_DESCRIPTION_EMPTY_TABLE"
  | "NO_BANNED_USERS"
  | "SUBMIT"
  | "ADD_DESCRIPTION"
  | "DESCRIPTION_ADDED"
  | "DESCRIPTION_DELETED"
  | "ADD_FLAGGED_DESCRIPTION_INVALID_INPUT"
  | "PLEASE_CONTACT_SE"
  | "TOTAL_USERS"
  | "TOTAL_CONVERSATIONS"
  | "NEW_CONVERSATIONS"
  | "TOTAL_MESSAGES"
  | "NEW_MESSAGES"
  | "SALES_USD"
  | "MARKETING_EXPENSES_USD"
  | "NO_CLEAN_POOL_DATA"
  | "NO_MORE_MESSAGES"
  | "KHATTABA_NAME"
  | "KHATTABA_AGE"
  | "KHATTABA_LOCATION"
  | "KHATTABA_CURRENCY"
  | "KHATTABA_CATEGORY"
  | "KHATTABA_PRICE"
  | "KHATTABA_LANGUAGE"
  | "KHATTABA_DESCRIPTION"
  | "LOCATION_FIELD"
  | "PRICE/EACH PRIDE"
  | "CURRENCY_I_WORK_WITH"
  | "MY_ID_TO_CONNECT"
  | "MORE_INFO_KHATTABAT"
  | "HELLO_MESSAGE"
  | "KHATTABAT"
  | "MALE_CLIENTS"
  | "FEMALE_CLIENTS"
  | "GET_KHATTABAT_CLIENTS"
  | "SUBSCRIPTION_ACTIVE"
  | "SUBSCRIPTION_EXPIRED"
  | "SEND"
  | "BLOCK"
  | "CREATE_ONE_O_TWO"
  | "ONE_O_ONE_C"
  | "ONE_O_TWO_WITH"
  | "COMMENTS"
  | "ONGOING"
  | "EXITED_BY_MATCH"
  | "EXITED_BY_CLIENT"
  | "PENDING_INTERACTION"
  | "ONE_O_ONE_M"
  | "MATCH_IDS"
  | "CLIENT_ID"
  | "SEND"
  | "ADD"
  | "ONE_O_ONE_M_SENT_RESULT"
  | "INCORRECT_CLIENT_ID"
  | "REFUND"
  | "CANCEL"
  | "NOT_UPDATED_CHECK_IF_CORRECT_PAYEMTN_INTENT"
  | "NOT_UPDATED_CHECK_IF_CORRECT_SUBSCRIPTION"
  | "ONE_O_TWO_CLIENT_MATCH_SAME_GENDER"
  | "CANNOT_CHANGE_TO_SAME_STATUS"
  | "USER_DOES_NOT_EXIST_OR_INACTIVE"
  | "ONE_O_TWO_CONVERSATION_ALREADY_CREATED"
  | "ALREADY_CANCELLED"
  | "CANCELLED"
  | "USER_DOES_NOT_EXIST_OR_INACTIVE"
  | "ONE_O_TWO_CONVERSATION_IS_NOT_ACTIVE_ANYMORE"
  | "DOUBLE_CLICK_FOR_GOOGLE_LENS"
  | "NO_WEB_USER_PAYMENT_ARCHIVE_DATA"
  | "WRONG_REFFERAL_CODE"
  | "ADMIN_USERS_HAVE_ALREADY_ANOTHER_ACTIVE_POOL"
  | "CLEAN_POOL_CONFIRMATION_POPUP"
  | "WEB_REFUND_ATTENTION"
  | "ARE_YOU_SURE_YOU_WANT_TO_CONTINUE"
  | "RECEIPT_ORIGINAL_TRANSACTION_ID"
  | "RECEIPT_PURCHASE_DATE"
  | "RECEIPT_EXPIRES_DATE"
  | "RECEIPT_IN_APP_OWNERSHIP_TYPE"
  | "RECEIPT_QUANTITY"
  | "RECEIPT_PURCHASE_DATE_MS"
  | "RECEIPT_PURCHASE_DATE_PST"
  | "RECEIPT_ORIGINAL_PURCHASE_DATE"
  | "RECEIPT_ORIGINAL_PURCHASE_MS"
  | "RECEIPT_ORIGINAL_PURCHASE_DATE_PST"
  | "RECEIPT_EXPIRES_DATE_MS"
  | "RECEIPT_EXPIRES_DATE_PST"
  | "RECEIPT_WEB_ORDER_LINE_ITEM_ID"
  | "RECEIPT_IS_TRIAL_PERIOD"
  | "RECEIPT_IS_IN_INTRO_OFFER_PERIOD"
  | "RECEIPT_APP_ACCOUNT_TOKEN"
  | "RECEIPT_HAS_PENDING"
  | "RECEIPT_PRODUCT_ID"
  | "LAST_RECEIPT_PRODUCT_ID"
  | "RECEIPT_EXPIRATION_INTENT"
  | "RECEIPT_IS_IN_BILLING_RETRY"
  | "LAST_RECEIPT_ORIGINAL_TRANSACTION_ID"
  | "RECEIPT_AUTO_RENEW_STATUS"
  | "RECEIPT_AUTO_RENEW_PRODUCT_ID"
  | "LAST_RECEIPT"
  | "PENDING_RECEIPTS"
  | "NO_RECEIPT"
  | "APPLE_RECEIPT_ERROR"
  | "ANDROID_RECEIPT_ERROR"
  | "CLIENT_IGNORE"
  | "CLIENT_PAID"
  | "CLIENT_LEAD"
  | "CLIENT_CONTACTED"
  | "CLIENT_NEW_CONTACT"
  | "TYPE_OF_MARRIAGE"
  | "REGULAR"
  | "POLY"
  | "MISYAR"
  | "LEAD"
  | "IGNORE"
  | "MOVE_TO"
  | "SELECT_ALL"
  | "COUNT_SELECTED"
  | "COUNT"
  | "FILTERS"
  | "MIN_AGE"
  | "MAX_AGE"
  | "UNDEFINED"
  | "APPLY"
  | "MAX_AGE_HAS_TO_BE_BIGGER_MIN_AGE"
  | "FILTERS_RESET"
  | "BULK_MESSAGES_BOX"
  | "PLEASE_AT_LEAST_ONE_USER"
  | "SENDING"
  | "MARK_AS_READ"
  | "UNREAD_MESSAGES"
  | "MATCHMAKING"
  | "KHATTABAT_MATCHING_SEARCH_AND_1O1M"
  | "KHATTABAT_MATCHING_RESULTS"
  | "NO_PAID_USERS_FOUND"
  | "PAID_USERS"
  | "RESULTS_NUMBER"
  | "CLEAR_RESULTS"
  | "NO_MATCHES_FOUND"
  | "CREATE_ONE_O_ONE_M"
  | "SEND_ONE_O_ONE_M_MESSAGE_PLACE_HOLDER"
  | "GET_CITIES"
  | "NO_CITIES_FOUND"
  | "GET_CONVESATIONS"
  | "NO_APPROVED_MATCHES_FOUND"
  | "CONTACTED"
  | "MATCH_APP_LANGUAGE"
  | "SUPERVISOR_RECEIPT_COMPENSATION"
  | "SUPERVISOR_RECEIPT_COMPENSATION_ISSUES_ADDED_SUCCESSFULLY"
  | "RECEIPT_FOUND_FOR_THIS_MONTH"
  | "SUBMIT_DATE_IS_SPECIFIC"
  | "DESCRIPTION_THRESHOLD"
  | "DESCRIPTION_DISCOUNT"
  | "DESCRIPTION_PRICING"
  | "REPORT_THRESHOLD"
  | "REPORT_DISCOUNT"
  | "REPORT_PRICING"
  | "INVESTIGATION_CASES_THRESHOLD"
  | "INVESTIGATION_CASES_DISCOUNT"
  | "INVESTIGATION_CASES_PRICING"
  | "PICTURE_THRESHOLD"
  | "PICTURE_DISCOUNT"
  | "PICTURE_PRICING"
  | "PREVIOUS_RECEIPT_MONTH"
  | "CURRENT_RECEIPT_MONTH"
  | "IMAGE_STATUS_DELETED"
  | "SENDING"
  | "SLOT"
  | "ALL_DAYS"
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY"
  | "CHOOSE_PROPER_TIME_RANGE"
  | "NO_LONGER_ACTIVE_POOL"
  | "UNSUBSCRIBED_USER_ACTIVITY_EMAILS"
  | "UNSUBSCRIBED_PROMOTIONAL_EMAILS"
  | "UNSUBSCRIBED_NEW_MESSAGE_EMAILS"
  | "UNSUBSCRIBED_VISIT_PROFILE_EMAILS"
  | "UNSUBSCRIBED_LIKE_EMAILS"
  | "DISABLE"
  | "ENABLE"
  | "ENABLE_SELECTED_1O1M"
  | "DISABLE_SELECTED_1O1M"
  | "PROFILE_ID"
  | "WRONG_PROFILE_ID"
  | "PROFILE_ID_NOT_FOUND"
  | "RESET_PASSWORD_CONFIRMATION_POPUP"
  | "USER_DATA"
  | "USER_PROFILE"
  | "USER_QUIZ"
  | "MARITAL_STATUS"
  | "EDUCATION_LEVEL"
  | "WORK_LEVEL"
  | "SMOKING_LEVEL"
  | "HAVING_KIDS"
  | "FEMALE_WORK_STUDY"
  | "BELONGS_TO_TRIBE"
  | "RELOCATION"
  | "HIGHLIGHT"
  | "THERE_IS_ANOTHER_AVAILABLE_KHATTABA"
  | "KHATTABAT_REMUNERATION"
  | "PER_CYCLE"
  | "KHATTABAT_ADMIN"
  | "NO_KHATTABAT_ADMIN"
  | "ADMIN_KHATTABAT_REMUNERATIONS"
  | "VIP"
  | "PLUS"
  | "KHATTABAT_TAG"
  | "BOOST"
  | "REWIND"
  | "READ"
  | "PLUS_DAYS"
  | "PLUS_HOURS"
  | "PLUS_MIN"
  | "MAKE_PLUS"
  | "KHATTABAT_DAYS"
  | "KHATTABAT_HOURS"
  | "KHATTABAT_MIN"
  | "MAKE_KHATTABAT"
  | "USER_IS_NOT_MALE_USER"
  | "USER_NEVER_PAYING_KHATTABAT"
  | "INCORRECT_PLUS_DAYS_HOURS"
  | "USER_PLUS_ADDED_SUCCESSFULLY"
  | "INCORRECT_KHATTABAT_DAYS_HOURS"
  | "USER_KHATTABAT_ADDED_SUCCESSFULLY"
  | "USER_IS_NOT_MATCHED_TO_THIS_KHATTABA"
  | "REASSIGNMENT_IS_COMPLETED"
  | "BAN_UNTIL"
  | "NUMBER_OF_DAYS"
  | "INVESTIGATION_ID"
  | "REPORT_ID"
  | "SUBSCRIPTION"
  | "AUDITORS_EFFICIENCY"
  | "TURN_KHATTABAT_ON_OFF"
  | "UPDATE"
  | "RC_CAPACITY"
  | "REACTIVATE"
  | "ACCOUNT_CREATED_ON"
  | "DELETED_BY_MATCH"
  | "AMOUNT"
  | "FREE_PAID_IN_HOURS_DAYS"
  | "ONE_O_TWO_CONFIRMATION_POPUP"
  | "KHATTABAT_ONE_O_TWO_HISTORIES_POPUP_TITLE"
  | "KHATTABAT_ONE_O_TWO_HISTORY_EVENT_ADDED"
  | "KHATTABAT_ONE_O_TWO_HISTORY_EVENT_UPDATED"
  | "KHATTABAT_ONE_O_TWO_HISTORY_EVENT_REMOVED"
  | "KHATTABAT_ONE_O_TWO_HISTORY_EVENT_HIDDEN"
  | "KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE_FOR_ME"
  | "KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE_FOR_EVERYONE"
  | "KHATTABAT_ONE_O_TWO_MESSAGE_HISTORY_BUTTON"
  | "KHATTABAT_ONE_O_TWO_HISTORY_SENDER"
  | "KHATTABAT_ONE_O_TWO_HISTORY_RECIPIENT"
  | "KHATTABAT_ONE_O_TWO_HISTORY_SENDER_KHATTABA"
  | "KHATTABAT_ONE_O_TWO_HISTORY_EVENT_CURRENT"
  | "SKIN_COLOR"
  | "RELIGION"
  | "VEIL"
  | "INCOME"
  | "MESSAGE_ERA"
  | "KHATTABAT_DATA"
  | "GET_LATEST"
  | "DATA_COLLECTION"
  | "NEW_CLIENTS"
  | "CAPACITY"
  | "ASSIGN_CLIENT_TO_ME"
  | "LIMIT_REACHED_KHATTABA_CLIENTS"
  | "NO_NEW_CLIENTS_AVAILABLE"
  | "CLIENT_ALREADY_ASSIGNED_TO_ANOTHER_KHATTABA"
  | "ASSIGN_NEW_CLIENT_CONFIRMATION_POP_UP"
  | "DOWNLOAD_CSV"
  | "INVOICE_NUMBER"
  | "SEARCH_BY_INVOICE_NUMBER"
  | "KHATTABA_102_COUNTER"
  | "CLIENT_102_COUNTER"
  | "MATCH_102_COUNTER"
  | "QUALITY"
  | "NOTICE_EMAIL"
  | "REACTIVATE_KHATTABA_CLIENT_CONFIRMATION_POP_UP"
  | "CANNOT_REACTIVATE_KHATTABA_CLIENT_POPUP"
  | "SILVER_SUBSCRIPTION_HISTORY_FOR"
  | "GOLD_SUBSCRIPTION_HISTORY_FOR"
  | "PLATINUM_SUBSCRIPTION_HISTORY_FOR"
  | "POWER_BUNDLE_SUBSCRIPTION_HISTORY_FOR"
  | "READ_SUBSCRIPTION_HISTORY_FOR"
  | "VIP_SUBSCRIPTION_HISTORY_FOR"
  | "PLUS_SUBSCRIPTION_HISTORY_FOR"
  | "KHATTABAT_SUBSCRIPTION_HISTORY_FOR"
  | "BOOST_SUBSCRIPTION_HISTORY_FOR"
  | "REWIND_SUBSCRIPTION_HISTORY_FOR"
  | "COUNT_HINT_SUBTEXT"
  | "SELFIE_VERIFICATION_PHOTOS"
  | "KHATTABA_V3_IS_ALREADY_TURNED_OFF"
  | "BP_USERS"
  | "SUB_TAB_ACCESS_SUMMARY"
  | "GENERATED_TABLES_SUMMARY"
  | "USER_UNDER_CSR_INVESTIGATION_BUT_WILL_APPEAR_SOON"
  | "MIN_WEIGHT"
  | "MAX_WEIGHT"
  | "MIN_HEIGHT"
  | "MAX_HEIGHT"
  | "MIN_AGE_LESS_THAN_MAX_AGE"
  | "MIN_WEIGHT_LESS_THAN_MAX_WEIGHT"
  | "MIN_HEIGHT_LESS_THAN_MAX_HEIGHT"
  | "FEATURE_ROLLOUT_PERCENTAGE"
  | "EXCLUDE"
  | "OTHER_AUDITORS_PERFORMANCE"
  | "BAN_SCAMMER"
  | "WARN_SOCIAL_MEDIA_ACCOUNT"
  | "WARN_BAD_LANGUAGE"
  | "ALL_CLIENTS"
  | "REQUIRES_ATTENTION"
  | "OTHER_AUDITORS_PERFORMANCE"
  | "REPORT_ACTIONS"
  | "REPORT_ACTION_REASONS"
  | "KHATTABA_QUIZ_STATUS"
  | "KHATTABA_QUIZ_STATS"
  | "NO_AI_APPLICATIONS_FOUND"
  | "AI_FILTER_USER_ID_DOMINANCE"
  | "INVALID_AGE"
  | "KHATTABA_V3_AI_IS_ALREADY_TURNED_OFF"
  | "PLATINUM"
  | "SILVER"
  | "GOLD"
  | "SILVER_DAYS"
  | "GOLD_DAYS"
  | "PLATINUM_DAYS"
  | "SILVER_HOURS"
  | "GOLD_HOURS"
  | "PLATINUM_HOURS"
  | "SILVER_MIN"
  | "GOLD_MIN"
  | "PLATINUM_MIN"
  | "MAKE_SILVER"
  | "MAKE_GOLD"
  | "MAKE_PLATINUM"
  | "USER_SILVER_ADDED_SUCCESSFULLY"
  | "USER_GOLD_ADDED_SUCCESSFULLY"
  | "USER_PLATINUM_ADDED_SUCCESSFULLY"
  | "USER_ADVANCED_ADDED_SUCCESSFULLY"
  | "APP_VERSION_BELOW_NINE_POINT_FIVE"
  | "SUBSCRIPTION_TIME_CONFIRMATION"
  | "PROMO_CODE_REWARD_TYPE"
  | "MAKE_ADVANCED"
  | "ADVANCED_DAYS"
  | "ADVANCED_HOURS"
  | "ADVANCED_MIN"
  | "ADVANCED_IOS"
  | "BUNDLE"
  | "SILVER_TAG"
  | "GOLD_TAG"
  | "PLATINUM_TAG"
  | "ACTIVE_FEATURE_SETS"
  | "ACTIVE_FEATURES"
  | "FEATURE_SET_ACTIVE_FEATURES"
  | "CONVERSATION_BADGE"
  | "LIKES"
  | "CONSUMABLES"
  | "OTHER_SUBSCRIPTION_HISTORY_FOR"
  | "TRIAL"
  | "SLACK_ALERTS"
  | "KHATTABAT_ASSIGN_REAL_USERS"
  | "KHATTABAT_ASSIGN_TESTER_USERS"
  | "KHATTABAT_SHOW_RESULTS"
  | "KHATTABAT_SELECTED_MATCHES"
  | "CONFIRM"
  | "SILENT_BAN_ABBREVIATION"
  | "SILENT_BANNED";

export const messageWithExtraData: Ti18nKeys[] = [
  "USER_ID_PICTURE_REJECT",
  "ONE_O_ONE_M_SENT_RESULT",
  "NEW_GENERATED_PASSWORD",
  "PROMO_CODE_GENERATED_SUCCESSFULLY"
];

export const messageWithArrayExtraData: Ti18nKeys[] = ["VIP_DETAILS"];

export enum TLanguageEnum {
  ENG = "ENG",
  AR = "AR",
  FR = "FR",
  TR = "TR"
}
export type TLanguage = "ENG" | "AR" | "FR" | "TR";
export type TI18nData = {
  AR: string;
  ENG: string;
  FR: string;
  TR: string;
};
export type TI18n = {
  LG: { [key in Ti18nKeys]: TI18nData };
  get: (message: Ti18nKeys) => string;
  getWithExtraData: (message: string, extraData: string) => string;
  getWithArrayExtraData: (message: string, extraData: string[]) => string;
  language: IObservableValue<TLanguage>;
};

const i18n: TI18n = {
  language: observable.box<TLanguage>("ENG"),

  LG: {
    CHOOSE: {
      ENG: "Choose",
      AR: "Choose",
      FR: "Choose",
      TR: "Choose"
    },
    ENVIRONMENT: {
      ENG: "Environment",
      AR: "Environment",
      FR: "Environment",
      TR: "Environment"
    },
    DEPLOYED: {
      ENG: "Deployed",
      AR: "Deployed",
      FR: "Deployed",
      TR: "Deployed"
    },
    GO_TO_MESSAGES: {
      ENG: "Messages",
      AR: "Messages",
      FR: "Messages",
      TR: "Messages"
    },
    GO_TO_USER_ADVANCED: {
      ENG: "UserAdvanced",
      AR: "UserAdvanced",
      FR: "UserAdvanced",
      TR: "UserAdvanced"
    },
    DANGER: {
      ENG: "Danger",
      AR: "Danger",
      FR: "Danger",
      TR: "Danger"
    },
    ALERT: {
      ENG: "Alert Mode",
      AR: "Alert Mode",
      FR: "Alert Mode",
      TR: "Alert Mode"
    },
    IP_GEOLOCATION: {
      ENG: "Ip geolocation",
      AR: "Ip geolocation",
      FR: "Ip geolocation",
      TR: "Ip geolocation"
    },
    RATE_LIMIT_MOBILE_APP: {
      ENG: "Rate Limit App",
      AR: "Rate Limit App",
      FR: "Rate Limit App",
      TR: "Rate Limit App"
    },

    RATE_LIMIT_WEBSITE: {
      ENG: "Rate Limit Website",
      AR: "Rate Limit Website",
      FR: "Rate Limit Website",
      TR: "Rate Limit Website"
    },

    RATE_LIMIT_ADMIN: {
      ENG: "Rate Limit Admin",
      AR: "Rate Limit Admin",
      FR: "Rate Limit Admin",
      TR: "Rate Limit Admin"
    },
    ALKHATTABA_ADMIN: {
      ENG: "Al-Khattaba Admin",
      AR: "Al-Khattaba Admin",
      FR: "Al-Khattaba Admin",
      TR: "Al-Khattaba Admin"
    },
    MAIN_NAVIGATION: {
      ENG: "Main Navigation",
      AR: "Main Navigation",
      FR: "Main Navigation",
      TR: "Main Navigation"
    },
    ET3ARRAF: {
      ENG: "et3arraf",
      AR: "et3arraf",
      FR: "et3arraf",
      TR: "et3arraf"
    },
    USERNAME: {
      ENG: "Username",
      AR: "Username",
      FR: "Username",
      TR: "Username"
    },
    PASSWORD: {
      ENG: "Password",
      AR: "Password",
      FR: "Password",
      TR: "Password"
    },
    SIGN_IN: {
      ENG: "Sign In",
      AR: "Sign In",
      FR: "Sign In",
      TR: "Sign In"
    },
    ERROR_MESSAGE: {
      ENG: "Unexpected error happened, please try again later",
      AR: "Unexpected error happened, please try again later",
      FR: "Unexpected error happened, please try again later",
      TR: "Unexpected error happened, please try again later"
    },
    LIMIT: {
      ENG: "Limit",
      AR: "Limit",
      FR: "Limit",
      TR: "Limit"
    },
    DATE_MIN: {
      ENG: "Date Min.",
      AR: "Date Min.",
      FR: "Date Min.",
      TR: "Date Min."
    },
    DATE_MAX: {
      ENG: "Date Max.",
      AR: "Date Max.",
      FR: "Date Max.",
      TR: "Date Max."
    },

    PLATFORM: {
      ENG: "Platform",
      AR: "Platform",
      FR: "Platform",
      TR: "Platform"
    },
    STATUS: {
      ENG: "Status",
      AR: "Status",
      FR: "Status",
      TR: "Status"
    },
    COUNTRY_CREATED_FROM: {
      ENG: "Country Created from",
      AR: "Country Created from",
      FR: "Country Created from",
      TR: "Country Created from"
    },
    TYPE: {
      ENG: "Type",
      AR: "Type",
      FR: "Type",
      TR: "Type"
    },
    COUNTRY: {
      ENG: "Country",
      AR: "Country",
      FR: "Country",
      TR: "Country"
    },
    SENDER_ID: {
      ENG: "Sender ID",
      AR: "Sender ID",
      FR: "Sender ID",
      TR: "Sender ID"
    },
    RECEIVER_ID: {
      ENG: "Receiver ID",
      AR: "Receiver ID",
      FR: "Receiver ID",
      TR: "Receiver ID"
    },
    ADMIN: {
      ENG: "Admin",
      AR: "Admin",
      FR: "Admin",
      TR: "Admin"
    },
    USER: {
      ENG: "User",
      AR: "User",
      FR: "User",
      TR: "User"
    },
    MONITOR_USER_MESSAGES: {
      ENG: "Monitor User Messages",
      AR: "Monitor User Messages",
      FR: "Monitor User Messages",
      TR: "Monitor User Messages"
    },
    USER_MESSAGES_TABLE: {
      ENG: "User Messages Table",
      AR: "User Messages Table",
      FR: "User Messages Table",
      TR: "User Messages Table"
    },
    USER_ID: {
      ENG: "User ID",
      AR: "User ID",
      FR: "User ID",
      TR: "User ID"
    },
    TRANSACTION_ID: {
      ENG: "Transaction ID",
      AR: "Transaction ID",
      FR: "Transaction ID",
      TR: "Transaction ID"
    },
    DEVICE_ID: {
      ENG: "Device ID",
      AR: "Device ID",
      FR: "Device ID",
      TR: "Device ID"
    },
    VIP_DAYS: {
      ENG: "Vip Days",
      AR: "Vip Days",
      FR: "Vip Days",
      TR: "Vip Days"
    },
    VIP_HOURS: {
      ENG: "Vip Hours",
      AR: "Vip Hours",
      FR: "Vip Hours",
      TR: "Vip Hours"
    },
    VIP_MIN: {
      ENG: "Vip Min",
      AR: "Vip Min",
      FR: "Vip Min",
      TR: "Vip Min"
    },
    SEARCH_BY: {
      ENG: "Search By",
      AR: "Search By",
      FR: "Search By",
      TR: "Search By"
    },
    GET: {
      ENG: "Get",
      AR: "Get",
      FR: "Get",
      TR: "Get"
    },
    VIEW_CONVERSATION: {
      ENG: "Conversation",
      AR: "Conversation",
      FR: "Conversation",
      TR: "Conversation"
    },
    GET_RESULTS: {
      ENG: "Get Results",
      AR: "Get Results",
      FR: "Get Results",
      TR: "Get Results"
    },
    EVENTS_LIST: {
      ENG: "Events List",
      AR: "Events List",
      FR: "Events List",
      TR: "Events List"
    },
    EVENTS_COUNT: {
      ENG: "Events Count",
      AR: "Events Count",
      FR: "Events Count",
      TR: "Events Count"
    },
    SEARCH_BY_USER_ID: {
      ENG: "By user id",
      AR: "By user id",
      FR: "By user id",
      TR: "By user id"
    },
    SEARCH_BY_TRANSACTION_ID: {
      ENG: "By transaction id",
      AR: "By transaction id",
      FR: "By transaction id",
      TR: "By transaction id"
    },
    ONLY_FOR_SE: {
      ENG: "Only for SE",
      AR: "Only for SE",
      FR: "Only for SE",
      TR: "Only for SE"
    },
    CHANGE_STATUS: {
      ENG: "Change Status",
      AR: "Change Status",
      FR: "Change Status",
      TR: "Change Status"
    },
    CHANGE_USERNAME: {
      ENG: "Change Username",
      AR: "Change Username",
      FR: "Change Username",
      TR: "Change Username"
    },
    MAKE_VIP: {
      ENG: "Make VIP",
      AR: "Make VIP",
      FR: "Make VIP",
      TR: "Make VIP"
    },
    FLAG: {
      ENG: "Flag",
      AR: "Flag",
      FR: "Flag",
      TR: "Flag"
    },
    RESET_ACCOUNT: {
      ENG: "Reset Account",
      AR: "Reset Account",
      FR: "Reset Account",
      TR: "Reset Account"
    },
    CLEAN_POOL: {
      ENG: "Clean Pool",
      AR: "Clean Pool",
      FR: "Clean Pool",
      TR: "Clean Pool"
    },
    PICTURE: {
      ENG: "Picture: ",
      AR: "Picture: ",
      FR: "Picture: ",
      TR: "Picture: "
    },
    DESCRIPTION: {
      ENG: "Description:",
      AR: "Description:",
      FR: "Description:",
      TR: "Description:"
    },
    NO_DESCRIPTION: {
      ENG: "No Description Added",
      AR: "No Description Added",
      FR: "No Description Added",
      TR: "No Description Added"
    },
    APPROVE: {
      ENG: "Approve",
      AR: "Approve",
      FR: "Approve",
      TR: "Approve"
    },
    REJECT: {
      ENG: "Reject",
      AR: "Reject",
      FR: "Reject",
      TR: "Reject"
    },
    APPROVED: {
      ENG: "Approved",
      AR: "Approved",
      FR: "Approved",
      TR: "Approved"
    },
    REJECTED: {
      ENG: "Rejected",
      AR: "Rejected",
      FR: "Rejected",
      TR: "Rejected"
    },
    REJECT_PICTURE: {
      ENG: "Reject Picture",
      AR: "Reject Picture",
      FR: "Reject Picture",
      TR: "Reject Picture"
    },
    REJECT_DESCRIPTION: {
      ENG: "Reject Description",
      AR: "Reject Description",
      FR: "Reject Description",
      TR: "Reject Description"
    },
    OLD_PASSWORD: {
      ENG: "Old Password",
      AR: "Old Password",
      FR: "Old Password",
      TR: "Old Password"
    },
    NEW_PASSWORD: {
      ENG: "New Password",
      AR: "New Password",
      FR: "New Password",
      TR: "New Password"
    },
    CONFIRM_PASSWORD: {
      ENG: "Confirm Password",
      AR: "Confirm Password",
      FR: "Confirm Password",
      TR: "Confirm Password"
    },
    CHANGE_ROLE: {
      ENG: "Change Role",
      AR: "Change Role",
      FR: "Change Role",
      TR: "Change Role"
    },
    CHANGE_PASSWORD: {
      ENG: "Change Password",
      AR: "Change Password",
      FR: "Change Password",
      TR: "Change Password"
    },
    RESOLVE: {
      ENG: "Resolve",
      AR: "Resolve",
      FR: "Resolve",
      TR: "Resolve"
    },
    WARN: {
      ENG: "Warn",
      AR: "Warn",
      FR: "Warn",
      TR: "Warn"
    },
    EMAIL: {
      ENG: "Email",
      AR: "Email",
      FR: "Email",
      TR: "Email"
    },
    BAN: {
      ENG: "Ban",
      AR: "Ban",
      FR: "Ban",
      TR: "Ban"
    },
    TEMPORARY_BAN: {
      ENG: "Temporary Ban",
      AR: "Temporary Ban",
      FR: "Temporary Ban",
      TR: "Temporary Ban"
    },
    SEARCH: {
      ENG: "Search",
      AR: "Search",
      FR: "Search",
      TR: "Search"
    },
    SEARCH_NO_RESULT: {
      ENG: "No Search Result",
      AR: "No Search Result",
      FR: "No Search Result",
      TR: "No Search Result"
    },
    SEARCH_SENSITIVE_CASE: {
      ENG: "Sensitive Case",
      AR: "Sensitive Case",
      FR: "Sensitive Case",
      TR: "Sensitive Case"
    },

    UPDATED_ON: {
      ENG: "updated on: ",
      AR: "updated on: ",
      FR: "updated on: ",
      TR: "updated on: "
    },
    REPORTS: {
      ENG: "Reports",
      AR: "Reports",
      FR: "Reports",
      TR: "Reports"
    },
    REPORTS_USER_TO_USER: {
      ENG: "reports from user to another",
      AR: "reports from user to another",
      FR: "reports from user to another",
      TR: "reports from user to another"
    },
    DASHBOARD: {
      ENG: "Dashboard",
      AR: "Dashboard",
      FR: "Dashboard",
      TR: "Dashboard"
    },
    CONTROL_PANEL: {
      ENG: "control panel",
      AR: "control panel",
      FR: "control panel",
      TR: "control panel"
    },
    CONVERSATION: {
      ENG: "Conversation",
      AR: "Conversation",
      FR: "Conversation",
      TR: "Conversation"
    },
    BETWEEN_TWO_USERS: {
      ENG: "between 2 users",
      AR: "between 2 users",
      FR: "between 2 users",
      TR: "between 2 users"
    },
    OH_ITS_ME: {
      ENG: "Oh, this is me. ",
      AR: "Oh, this is me. ",
      FR: "Oh, this is me. ",
      TR: "Oh, this is me. "
    },
    OH_NO: {
      ENG: "OH NO!",
      AR: "OH NO!",
      FR: "OH NO!",
      TR: "OH NO!"
    },
    WARNING: {
      ENG: "Warning!",
      AR: "Warning!",
      FR: "Warning!",
      TR: "Warning!"
    },
    SUCCESS: {
      ENG: "Success!",
      AR: "Success!",
      FR: "Success!",
      TR: "Success!"
    },
    APPROVAL: {
      ENG: "Approval",
      AR: "Approval",
      FR: "Approval",
      TR: "Approval"
    },
    APPROVE_USER_DATA: {
      ENG: "approve user pictures/descriptions",
      AR: "approve user pictures/descriptions",
      FR: "approve user pictures/descriptions",
      TR: "approve user pictures/descriptions"
    },
    MONITOR_USER_PAYMENTS: {
      ENG: "monitor user payments",
      AR: "monitor user payments",
      FR: "monitor user payments",
      TR: "monitor user payments"
    },
    MONITOR_USER_LOGIN: {
      ENG: "monitor user login",
      AR: "monitor user login",
      FR: "monitor user login",
      TR: "monitor user login"
    },
    USER_LOGIN_TABLE: {
      ENG: "User Login Table",
      AR: "User Login Table",
      FR: "User Login Table",
      TR: "User Login Table"
    },
    USER_ACTION_BUTTONS: {
      ENG: "User Action Buttons",
      AR: "User Action Buttons",
      FR: "User Action Buttons",
      TR: "User Action Buttons"
    },
    MONITOR_USER_EVENTS: {
      ENG: "monitor user events",
      AR: "monitor user events",
      FR: "monitor user events",
      TR: "monitor user events"
    },
    ADVANCED_MODE: {
      ENG: "advanced mode",
      AR: "advanced mode",
      FR: "advanced mode",
      TR: "advanced mode"
    },

    INFO_ABOUT_USER_ACTIVITIES: {
      ENG: "info. about user activities",
      AR: "info. about user activities",
      FR: "info. about user activities",
      TR: "info. about user activities"
    },

    GET_SIDED_STATISTICS: {
      ENG: "get sided statistics",
      AR: "get sided statistics",
      FR: "get sided statistics",
      TR: "get sided statistics"
    },
    VIEW_EDIT_ADMIN_POOL: {
      ENG: "view/edit admin pool",
      AR: "view/edit admin pool",
      FR: "view/edit admin pool",
      TR: "view/edit admin pool"
    },
    POOL_TABLE: {
      ENG: "Pool Table",
      AR: "Pool Table",
      FR: "Pool Table",
      TR: "Pool Table"
    },
    VIEW_EDIT_ADMIN_PERMISSION: {
      ENG: "view/edit admin permission",
      AR: "view/edit admin permission",
      FR: "view/edit admin permission",
      TR: "view/edit admin permission"
    },
    INVESTIGATION_CASES: {
      ENG: "Investigation Cases",
      AR: "Investigation Cases",
      FR: "Investigation Cases",
      TR: "Investigation Cases"
    },
    ADMIN_EVENTS: {
      ENG: "Admin Events",
      AR: "Admin Events",
      FR: "Admin Events",
      TR: "Admin Events"
    },
    VIEW_ADMIN_EVENTS: {
      ENG: "view/audit admin events",
      AR: "view/audit admin events",
      FR: "view/audit admin events",
      TR: "view/audit admin events"
    },
    VIEW_ADMIN_EVENTS_CHARTS: {
      ENG: "view admin events charts",
      AR: "view admin events charts",
      FR: "view admin events charts",
      TR: "view admin events charts"
    },
    VIEW_ADMIN_AUDITED_EVENTS: {
      ENG: "view admin events Audited",
      AR: "view admin events Audited",
      FR: "view admin events Audited",
      TR: "view admin events Audited"
    },
    COPYRIGHT: {
      ENG: "Copyright © 2012-2025 ",
      AR: "Copyright © 2012-2025 ",
      FR: "Copyright © 2012-2025 ",
      TR: "Copyright © 2012-2025 "
    },
    ET3ARRAF_SAL: {
      ENG: "et3arraf SAL. ",
      AR: "et3arraf SAL. ",
      FR: "et3arraf SAL. ",
      TR: "et3arraf SAL. "
    },
    ALL_RIGHTS_RESERVED: {
      ENG: "All rights reserved",
      AR: "All rights reserved",
      FR: "All rights reserved",
      TR: "All rights reserved"
    },
    VERSION: {
      ENG: "Version",
      AR: "Version",
      FR: "Version",
      TR: "Version"
    },
    APPROVE_REJECT_DATA: {
      ENG: "Approve / Reject data",
      AR: "Approve / Reject data",
      FR: "Approve / Reject data",
      TR: "Approve / Reject data"
    },

    USER_MESSAGES: {
      ENG: "User Messages",
      AR: "User Messages",
      FR: "User Messages",
      TR: "User Messages"
    },
    USER_PAYMENTS: {
      ENG: "User Payments",
      AR: "User Payments",
      FR: "User Payments",
      TR: "User Payments"
    },
    USER_EVENTS: {
      ENG: "User Events",
      AR: "User Events",
      FR: "User Events",
      TR: "User Events"
    },
    COMMUNITY: {
      ENG: "1- Community",
      AR: "1- Community",
      FR: "1- Community",
      TR: "1- Community"
    },
    ENGAGMENT: {
      ENG: "2- Engagment",
      AR: "2- Engagment",
      FR: "2- Engagment",
      TR: "2- Engagment"
    },
    FINANCIALS: {
      ENG: "3- Financials",
      AR: "3- Financials",
      FR: "3- Financials",
      TR: "3- Financials"
    },
    USER_LOCATION_CHART_TITLE: {
      ENG: "Geographical repartition of active users for last month",
      AR: "Geographical repartition of active users for last month",
      FR: "Geographical repartition of active users for last month",
      TR: "Geographical repartition of active users for last month"
    },
    USER_GENDER_CHART_TITLE: {
      ENG: "Geographical repartition of active users for last month",
      AR: "Geographical repartition of active users for last month",
      FR: "Geographical repartition of active users for last month",
      TR: "Geographical repartition of active users for last month"
    },
    GCC_COUNTRIES: {
      ENG: "GCC=UAE,Qatar,Bahrain and Kuwait",
      AR: "GCC=UAE,Qatar,Bahrain and Kuwait",
      FR: "GCC=UAE,Qatar,Bahrain and Kuwait",
      TR: "GCC=UAE,Qatar,Bahrain and Kuwait"
    },
    LEVANT_COUNTRIES: {
      ENG: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon",
      AR: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon",
      FR: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon",
      TR: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon"
    },
    NA_COUNTRIES: {
      ENG: "NA=Morocco,Algeria and Tunisia",
      AR: "NA=Morocco,Algeria and Tunisia",
      FR: "NA=Morocco,Algeria and Tunisia",
      TR: "NA=Morocco,Algeria and Tunisia"
    },
    OTHER_COUNTRIES: {
      ENG: "Others=Over 100 countries",
      AR: "Others=Over 100 countries",
      FR: "Others=Over 100 countries",
      TR: "Others=Over 100 countries"
    },
    TOTAL_CONVERSATIONS_CHART_TITLE: {
      ENG: "Total number of conversations created",
      AR: "Total number of conversations created",
      FR: "Total number of conversations created",
      TR: "Total number of conversations created"
    },
    TOTAL_MONTHLY_CONVERSATIONS_CHART_TITLE: {
      ENG: "Total number of conversations created per month",
      AR: "Total number of conversations created per month",
      FR: "Total number of conversations created per month",
      TR: "Total number of conversations created per month"
    },
    TWO_SIDED_CONVERSATION_RATIO: {
      ENG: "Ratio of 2 sided conversations per month",
      AR: "Ratio of 2 sided conversations per month",
      FR: "Ratio of 2 sided conversations per month",
      TR: "Ratio of 2 sided conversations per month"
    },
    TOTAL_USERS_NUMBERS: {
      ENG: "Total number of users",
      AR: "Total number of users",
      FR: "Total number of users",
      TR: "Total number of users"
    },
    TOTAL_MONTHLY_NEW_USERS: {
      ENG: "Total number of new users per month",
      AR: "Total number of new users per month",
      FR: "Total number of new users per month",
      TR: "Total number of new users per month"
    },
    EXPENSES_PER_MONTH: {
      ENG: "Expenses per month",
      AR: "Expenses per month",
      FR: "Expenses per month",
      TR: "Expenses per month"
    },
    APPROVE_REJECT: {
      ENG: "Approve Reject",
      AR: "Approve Reject",
      FR: "Approve Reject",
      TR: "Approve Reject"
    },
    LAST_LOGIN: {
      ENG: "Last login",
      AR: "Last login",
      FR: "Last login",
      TR: "Last login"
    },
    SIGN_OUT: {
      ENG: "Sign out",
      AR: "Sign out",
      FR: "Sign out",
      TR: "Sign out"
    },
    REASON: {
      ENG: "Reason: ",
      AR: "Reason: ",
      FR: "Reason: ",
      TR: "Reason: "
    },
    COMMENT: {
      ENG: "Comment: ",
      AR: "Comment: ",
      FR: "Comment: ",
      TR: "Comment: "
    },
    REPORTER: {
      ENG: "Reporter",
      AR: "Reporter",
      FR: "Reporter",
      TR: "Reporter"
    },
    REPORTED: {
      ENG: "Reported",
      AR: "Reported",
      FR: "Reported",
      TR: "Reported"
    },
    REFRESH: {
      ENG: "Refresh",
      AR: "Refresh",
      FR: "Refresh",
      TR: "Refresh"
    },
    REPORT_REASON_1: {
      ENG: "Bad Language",
      AR: "Bad Language",
      FR: "Bad Language",
      TR: "Bad Language"
    },
    REPORT_REASON_2: {
      ENG: "Fake profile",
      AR: "Fake profile",
      FR: "Fake profile",
      TR: "Fake profile"
    },
    REPORT_REASON_3: {
      ENG: "Impersonation",
      AR: "Impersonation",
      FR: "Impersonation",
      TR: "Impersonation"
    },
    REPORT_REASON_4: {
      ENG: "Inappropriate Picture",
      AR: "Inappropriate Picture",
      FR: "Inappropriate Picture",
      TR: "Inappropriate Picture"
    },
    REPORT_REASON_5: {
      ENG: "Other",
      AR: "Other",
      FR: "Other",
      TR: "Other"
    },
    PAID: {
      ENG: "Paid",
      AR: "Paid",
      FR: "Paid",
      TR: "Paid"
    },
    NOT_PAID: {
      ENG: "Not Paid",
      AR: "Not Paid",
      FR: "Not Paid",
      TR: "Not Paid"
    },
    INVALID_CREDENTIALS: {
      ENG: "Invalid credentials",
      AR: "Invalid credentials",
      FR: "Invalid credentials",
      TR: "Invalid credentials"
    },
    INCORRECT_NEWPASSWORD: {
      ENG: "New password doesn't match",
      AR: "New password doesn't match",
      FR: "New password doesn't match",
      TR: "New password doesn't match"
    },
    INCORRECT_OLD_PASSWORD: {
      ENG: "Old password is incorrect",
      AR: "Old password is incorrect",
      FR: "Old password is incorrect",
      TR: "Old password is incorrect"
    },
    SERVER_ENCOUNTERED_ERROR: {
      ENG: "An error occurred, please try again",
      AR: "An error occurred, please try again",
      FR: "An error occurred, please try again",
      TR: "An error occurred, please try again"
    },
    PASSWORD_CHANGE_SUCCESSFUL: {
      ENG: "Password changed successfully",
      AR: "Password changed successfully",
      FR: "Password changed successfully",
      TR: "Password changed successfully"
    },
    WRONG_INPUT: {
      ENG: "Wrong Input",
      AR: "Wrong Input",
      FR: "Wrong Input",
      TR: "Wrong Input"
    },
    LOADING: {
      ENG: "Loading ...",
      AR: "Loading ...",
      FR: "Loading ...",
      TR: "Loading ..."
    },
    ACCEPT: { ENG: "Accept", AR: "Accept", FR: "Accept", TR: "Accept" },
    ACCEPT_DESCRIPTION: {
      ENG: "Accept Description",
      AR: "Accept Description",
      FR: "Accept Description",
      TR: "Accept Description"
    },
    ACCEPT_PICTURE: {
      ENG: "Accept Picture",
      AR: "Accept Picture",
      FR: "Accept Picture",
      TR: "Accept Picture"
    },
    USER_STATUS_CHANGED_SUCCESSFULLY: {
      ENG: "User status changed successfully",
      AR: "User status changed successfully",
      FR: "User status changed successfully",
      TR: "User status changed successfully"
    },
    USER_NAME_CHANGED_SUCCESSFULLY: {
      ENG: "Username changed successfully",
      AR: "Username changed successfully",
      FR: "Username changed successfully",
      TR: "Username changed successfully"
    },
    USER_VIP_ADDED_SUCCESSFULLY: {
      ENG: "User VIP added successfully",
      AR: "User VIP added successfully",
      FR: "User VIP added successfully",
      TR: "User VIP added successfully"
    },
    USER_FLAGGED_SUCCESSFULLY: {
      ENG: "User flagged successfully",
      AR: "User flagged successfully",
      FR: "User flagged successfully",
      TR: "User flagged successfully"
    },
    USER_GENDER_CHANGED_SUCCESSFULLY: {
      ENG: "User gender changed successfully to new user id : %EXTRA_DATA%",
      AR: "User gender changed successfully to new user id : %EXTRA_DATA%",
      FR: "User gender changed successfully to new user id : %EXTRA_DATA%",
      TR: "User gender changed successfully to new user id : %EXTRA_DATA%"
    },
    DESCRIPTION_REJECTED_SUCCESSFULLY: {
      ENG: "Description Rejected Successfully",
      AR: "Description Rejected Successfully",
      FR: "Description Rejected Successfully",
      TR: "Description Rejected Successfully"
    },
    PEER_DESCRIPTION_REJECTED_SUCCESSFULLY: {
      ENG: "Peer Description Rejected Successfully",
      AR: "Peer Description Rejected Successfully",
      FR: "Peer Description Rejected Successfully",
      TR: "Peer Description Rejected Successfully"
    },
    DESCRIPTION_APPROVED_SUCCESSFULLY: {
      ENG: "Description Approved Successfully",
      AR: "Description Approved Successfully",
      FR: "Description Approved Successfully",
      TR: "Description Approved Successfully"
    },
    PEER_DESCRIPTION_APPROVED_SUCCESSFULLY: {
      ENG: "Peer Description Approved Successfully",
      AR: "Peer Description Approved Successfully",
      FR: "Peer Description Approved Successfully",
      TR: "Peer Description Approved Successfully"
    },
    PICTURE_REJECTED_SUCCESSFULLY: {
      ENG: "Picture Rejected Successfully",
      AR: "Picture Rejected Successfully",
      FR: "Picture Rejected Successfully",
      TR: "Picture Rejected Successfully"
    },
    PICTURE_APPROVED_SUCCESSFULLY: {
      ENG: "Picture Approved Successfully",
      AR: "Picture Approved Successfully",
      FR: "Picture Approved Successfully",
      TR: "Picture Approved Successfully"
    },
    ORDER: {
      ENG: "Order",
      AR: "Order",
      FR: "Order",
      TR: "Order"
    },
    USER_EVENTS_TABLE: {
      ENG: "User Events Table",
      AR: "User Events Table",
      FR: "User Events Table",
      TR: "User Events Table"
    },
    USER_DEVICES_TABLE: {
      ENG: "User Devices Table",
      AR: "User Devices Table",
      FR: "User Devices Table",
      TR: "User Devices Table"
    },
    DEVICE_UNLINKED_SUCCESSFULLY: {
      ENG: "Device Unlinked Successfully",
      AR: "Device Unlinked Successfully",
      FR: "Device Unlinked Successfully",
      TR: "Device Unlinked Successfully"
    },
    MESSAGES_SEND_FROM: {
      ENG: "Messages Sent between %EXTRA_DATA%",
      AR: "Messages Sent between %EXTRA_DATA%",
      FR: "Messages Sent between %EXTRA_DATA%",
      TR: "Messages Sent between %EXTRA_DATA%"
    },
    FROM: {
      ENG: "From: ",
      AR: "From: ",
      FR: "From: ",
      TR: "From: "
    },
    TO: {
      ENG: "To: ",
      AR: "To: ",
      FR: "To: ",
      TR: "To: "
    },
    ACTION_TAKEN: {
      ENG: "Action Taken",
      AR: "Action Taken",
      FR: "Action Taken",
      TR: "Action Taken"
    },

    TBW: {
      ENG: "TBW",
      AR: "TBW",
      FR: "TBW",
      TR: "TBW"
    },
    TBW_REASONS: {
      ENG: "T.B.W Reasons ",
      AR: "T.B.W Reasons ",
      FR: "T.B.W Reasons ",
      TR: "T.B.W Reasons "
    },
    SELECT_REASONS_OF_ACTION: {
      ENG: "Please select the reasons for %EXTRA_DATA%",
      AR: "Please select the reasons for %EXTRA_DATA%",
      FR: "Please select the reasons for %EXTRA_DATA%",
      TR: "Please select the reasons for %EXTRA_DATA%"
    },
    ACTIVE: {
      ENG: "Active",
      AR: "Active",
      FR: "Active",
      TR: "Active"
    },
    WRONG_AND_FIX: {
      ENG: "Fix Wrong",
      AR: "Fix Wrong",
      FR: "Fix Wrong",
      TR: "Fix Wrong"
    },
    CORRECT: {
      ENG: "Correct",
      AR: "Correct",
      FR: "Correct",
      TR: "Correct"
    },
    WRONG: {
      ENG: "Wrong",
      AR: "Wrong",
      FR: "Wrong",
      TR: "Wrong"
    },
    INCORRECT_VIP_DAYS_HOURS: {
      ENG: "Cannot give less than one day vip and lass than one hour to a user",
      AR: "Cannot give less than one day vip and lass than one hour to a user",
      FR: "Cannot give less than one day vip and lass than one hour to a user",
      TR: "Cannot give less than one day vip and lass than one hour to a user"
    },
    SELECT_SMALLER_DATE_RANGE: {
      ENG: "Select smaller date range (max. 1 month)",
      AR: "Select smaller date range (max. 1 month)",
      FR: "Select smaller date range (max. 1 month)",
      TR: "Select smaller date range (max. 1 month)"
    },
    SELECT_CORRECT_DATE_RANGE: {
      ENG: "Select correct date range",
      AR: "Select correct date range",
      FR: "Select correct date range",
      TR: "Select correct date range"
    },
    CHECK_START_EXPIRY_DATE: {
      AR: "Check your start date or expiry date",
      ENG: "Check your start date or expiry date",
      FR: "Check your start date or expiry date",
      TR: "Check your start date or expiry date"
    },
    GENDER: {
      ENG: "Gender",
      AR: "Gender",
      FR: "Gender",
      TR: "Gender"
    },
    USER_ADVANCED_TABLE: {
      ENG: "User Advanced Table",
      AR: "User Advanced Table",
      FR: "User Advanced Table",
      TR: "User Advanced Table"
    },
    USER_ADVANCED_QUIZ_TABLE: {
      ENG: "User Advanced Quiz Table",
      AR: "User Advanced Quiz Table",
      FR: "User Advanced Quiz Table",
      TR: "User Advanced Quiz Table"
    },
    USER_QUIZ: {
      ENG: "User Quiz",
      AR: "User Quiz",
      FR: "User Quiz",
      TR: "User Quiz"
    },
    USER_ADVANCED_EMAIL_TABLE: {
      ENG: "Emails",
      AR: "Emails",
      FR: "Emails",
      TR: "Emails"
    },
    VIEW_EDIT_ADMIN_DASHBOARD: {
      ENG: "View/Edit admin dashboard",
      AR: "View/Edit admin dashboard",
      FR: "View/Edit admin dashboard",
      TR: "View/Edit admin dashboard"
    },
    MINOR_ISSUE: {
      ENG: "Minor Issue",
      AR: "Minor Issue",
      FR: "Minor Issue",
      TR: "Minor Issue"
    },
    MAJOR_ISSUE: {
      ENG: "Major Issue",
      AR: "Major Issue",
      FR: "Major Issue",
      TR: "Major Issue"
    },
    NO_ISSUE: {
      ENG: "No Issue",
      AR: "No Issue",
      FR: "No Issue",
      TR: "No Issue"
    },
    USER_WARNED: {
      ENG: "User Warned",
      AR: "User Warned",
      FR: "User Warned",
      TR: "User Warned"
    },
    REPORT_RESOLVE: {
      ENG: "Report Resolved",
      AR: "Report Resolved",
      FR: "Report Resolved",
      TR: "Report Resolved"
    },
    REPORT_EMAIL: {
      ENG: "Report Email",
      AR: "Report Email",
      FR: "Report Email",
      TR: "Report Email"
    },
    USER_BANNED: {
      ENG: "User Banned",
      AR: "User Banned",
      FR: "User Banned",
      TR: "User Banned"
    },
    USER_TEMPORARY_BANNED: {
      ENG: "User Temporary banned",
      AR: "User Temporary banned",
      FR: "User Temporary banned",
      TR: "User Temporary banned"
    },
    AUDIT_PERFORMANCE: {
      ENG: "Auditing Performance",
      AR: "Auditing Performance",
      FR: "Auditing Performance",
      TR: "Auditing Performance"
    },
    IMAGE_DELETED: {
      ENG: "DELETED BY USER",
      AR: "DELETED BY USER",
      FR: "DELETED BY USER",
      TR: "DELETED BY USER"
    },
    MARK_SEEN: {
      ENG: "Mark Seen",
      AR: "Mark Seen",
      FR: "Mark Seen",
      TR: "Mark Seen"
    },
    AUDIT_EFFICIENCY: {
      ENG: "Auditing Efficiency",
      AR: "Auditing Efficiency",
      FR: "Auditing Efficiency",
      TR: "Auditing Efficiency"
    },
    Admin_Audit_Helper_Text: {
      ENG: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page.",
      AR: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page.",
      FR: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page.",
      TR: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page."
    },
    Admin_Audit_Events_Helper_Text: {
      ENG: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR.",
      AR: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR.",
      FR: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR.",
      TR: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR."
    },
    Supervise_Helper_Text: {
      ENG: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab.",
      AR: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab.",
      FR: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab.",
      TR: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab."
    },
    Supervise_Events_Helper_Text: {
      ENG: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR.",
      AR: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR.",
      FR: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR.",
      TR: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR."
    },
    MONITOR_USER_MESSAGE_ID: {
      ENG: "monitor user messages by id",
      AR: "monitor user messages by id",
      FR: "monitor user messages by id",
      TR: "monitor user messages by id"
    },
    MESSAGE_ID: {
      ENG: "Message Id",
      AR: "Message Id",
      FR: "Message Id",
      TR: "Message Id"
    },
    USER_MESSAGES_ID_TABLE: {
      ENG: "User Message Id Table",
      AR: "User Message Id Table",
      FR: "User Message Id Table",
      TR: "User Message Id Table"
    },
    WRONG_MESSAGE_ID: {
      ENG: "Wrong Message Id",
      AR: "Wrong Message Id",
      FR: "Wrong Message Id",
      TR: "Wrong Message Id"
    },
    WORKLOAD_DATA_BETWEEN_TWO_DATES: {
      ENG: "Workload data between two dates",
      AR: "Workload data between two dates",
      FR: "Workload data between two dates",
      TR: "Workload data between two dates"
    },
    WORKLOAD_TABLE: {
      ENG: "Workload Table",
      AR: "Workload Table",
      FR: "Workload Table",
      TR: "Workload Table"
    },
    AUDITING_PERFORMANCE: {
      ENG: "Auditing Performance",
      AR: "Auditing Performance",
      FR: "Auditing Performance",
      TR: "Auditing Performance"
    },
    AUDITING_PERFORMANCE_DASHBOARD: {
      ENG: "Auditing Performance Table",
      AR: "Auditing Performance Table",
      FR: "Auditing Performance Table",
      TR: "Auditing Performance Table"
    },
    DATE_RANGE: {
      ENG: "Date Range",
      AR: "Date Range",
      FR: "Date Range",
      TR: "Date Range"
    },
    USER_EDIT_PROFILE: {
      ENG: "Edit profile",
      AR: "Edit profile",
      FR: "Edit profile",
      TR: "Edit profile"
    },
    USER_EDIT_PROFILE_ARCHIVE: {
      ENG: "Edit profile history",
      AR: "Edit profile history",
      FR: "Edit profile history",
      TR: "Edit profile history"
    },
    EDIT_USER_DATA: {
      ENG: "Edit Profile",
      AR: "Edit Profile",
      FR: "Edit Profile",
      TR: "Edit Profile"
    },
    INVALID_PASSWORD: {
      ENG: "Password should be between 6 and 20 latin characters composed of letters and digits at least",
      AR: "Password should be between 6 and 20 latin characters composed of letters and digits at least",
      FR: "Password should be between 6 and 20 latin characters composed of letters and digits at least",
      TR: "Password should be between 6 and 20 latin characters composed of letters and digits at least"
    },
    INCORRECT_PASSWORD_REPEATED: {
      ENG: "You cannot use your old password!",
      AR: "You cannot use your old password!",
      FR: "You cannot use your old password!",
      TR: "You cannot use your old password!"
    },
    USER_REFERRAL_CODE_USAGE_TABLE: {
      ENG: "User Referral Code Usage Table",
      AR: "User Referral Code Usage Table",
      FR: "User Referral Code Usage Table",
      TR: "User Referral Code Usage Table"
    },
    WRONG_USER_ID: {
      ENG: "Wrong User Id",
      AR: "Wrong User Id",
      FR: "Wrong User Id",
      TR: "Wrong User Id"
    },
    USER_DATA_CHANGED: {
      AR: "User Data Changed",
      ENG: "User Data Changed",
      FR: "User Data Changed",
      TR: "User Data Changed"
    },
    USER_BANNED_SUCCESSFULLY: {
      AR: "User Banned Successfully",
      ENG: "User Banned Successfully",
      FR: "User Banned Successfully",
      TR: "User Banned Successfully"
    },
    USER_WARNED_SUCCESSFULLY: {
      AR: "User Warned Successfully",
      ENG: "User Warned Successfully",
      FR: "User Warned Successfully",
      TR: "User Warned Successfully"
    },
    POOL_CLEANED: {
      AR: "Pool Cleaned",
      ENG: "Pool Cleaned",
      FR: "Pool Cleaned",
      TR: "Pool Cleaned"
    },
    USER_LATEST_RECEIPT: {
      AR: "User Latest Receipt",
      ENG: "User Latest Receipt",
      FR: "User Latest Receipt",
      TR: "User Latest Receipt"
    },
    LOAD_MORE: {
      AR: "Load More",
      ENG: "Load More",
      FR: "Load More",
      TR: "Load More"
    },
    TESTER: {
      AR: "Tester",
      ENG: "Tester",
      FR: "Tester",
      TR: "Tester"
    },
    OPTIONS: {
      AR: "Options",
      ENG: "Options",
      FR: "Options",
      TR: "Options"
    },
    ADD_TBW: {
      AR: "Add TBW",
      ENG: "Add TBW",
      FR: "Add TBW",
      TR: "Add TBW"
    },
    ISSUE_TYPE: {
      AR: "Issue Type",
      ENG: "Issue Type",
      FR: "Issue Type",
      TR: "Issue Type"
    },
    PAYMENT_PACKAGES_TODAY: {
      AR: "Payment Packages For ToDay",
      ENG: "Payment Packages For ToDay",
      FR: "Payment Packages For ToDay",
      TR: "Payment Packages For ToDay"
    },
    PAYMENT_PACKAGES_PREV_DAY: {
      AR: "Payment Packages For Prev Day",
      ENG: "Payment Packages For Prev Day",
      FR: "Payment Packages For Prev Day",
      TR: "Payment Packages For Prev Day"
    },
    PACKAGE_NOTIFICATION_TYPE_COUNT: {
      AR: "Packages Notifications Type Count For Last Day",
      ENG: "Packages Notifications Type Count For Last Day",
      FR: "Packages Notifications Type Count For Last Day",
      TR: "Packages Notifications Type Count For Last Day"
    },
    COPY: {
      AR: "Copy",
      ENG: "Copy",
      FR: "Copy",
      TR: "Copy"
    },
    STATS_DASHBOARD: {
      AR: "Stats Dashboard",
      ENG: "Stats Dashboard",
      FR: "Stats Dashboard",
      TR: "Stats Dashboard"
    },
    PERFORMANCE: {
      AR: "Performance",
      ENG: "Performance",
      FR: "Performance",
      TR: "Performance"
    },
    EFFECTIVENESS: {
      AR: "Effectiveness",
      ENG: "Effectiveness",
      FR: "Effectiveness",
      TR: "Effectiveness"
    },

    USER_EMAIL_EVENTS_TABLE: {
      AR: "User Email Events Table",
      ENG: "User Email Events Table",
      FR: "User Email Events Table",
      TR: "User Email Events Table"
    },
    USER_DEACTIVATIONS_TABLE: {
      AR: "Deactivation Activity",
      ENG: "Deactivation Activity",
      FR: "Deactivation Activity",
      TR: "Deactivation Activity"
    },

    IOS_PAYMENTS: {
      AR: "IOS Payments",
      ENG: "IOS Payments",
      FR: "IOS Payments",
      TR: "IOS Payments"
    },
    ANDROID_PAYMENTS: {
      AR: "Android Payments",
      ENG: "Android Payments",
      FR: "Android Payments",
      TR: "Android Payments"
    },
    LAST_LOGIN_USERS: {
      AR: "Last Login Users",
      ENG: "Last Login Users",
      FR: "Last Login Users",
      TR: "Last Login Users"
    },
    EMAIL_USERS: {
      AR: "Email Users",
      ENG: "Email Users",
      FR: "Email Users",
      TR: "Email Users"
    },
    EMAIL_SENT: {
      AR: "Email Sent",
      ENG: "Email Sent",
      FR: "Email Sent",
      TR: "Email Sent"
    },
    SENT_EMAILS: {
      AR: "Sent Emails",
      ENG: "Sent Emails",
      FR: "Sent Emails",
      TR: "Sent Emails"
    },
    UNSUBSCRIBED_USER_ACTIVITY_EMAILS: {
      AR: "Unsubscribed User Activity Emails",
      ENG: "Unsubscribed User Activity Emails",
      FR: "Unsubscribed User Activity Emails",
      TR: "Unsubscribed User Activity Emails"
    },
    UNSUBSCRIBED_PROMOTIONAL_EMAILS: {
      AR: "Unsubscribed Promotional Emails",
      ENG: "Unsubscribed Promotional Emails",
      FR: "Unsubscribed Promotional Emails",
      TR: "Unsubscribed Promotional Emails"
    },
    UNSUBSCRIBED_NEW_MESSAGE_EMAILS: {
      AR: "Unsubscribed New Message Emails",
      ENG: "Unsubscribed New Message Emails",
      FR: "Unsubscribed New Message Emails",
      TR: "Unsubscribed New Message Emails"
    },
    UNSUBSCRIBED_VISIT_PROFILE_EMAILS: {
      AR: "Unsubscribed Visit Profile Emails",
      ENG: "Unsubscribed Visit Profile Emails",
      FR: "Unsubscribed Visit Profile Emails",
      TR: "Unsubscribed Visit Profile Emails"
    },
    UNSUBSCRIBED_LIKE_EMAILS: {
      AR: "Unsubscribed Like Emails",
      ENG: "Unsubscribed Like Emails",
      FR: "Unsubscribed Like Emails",
      TR: "Unsubscribed Like Emails"
    },
    SMS_USERS: {
      AR: "Sms Users",
      ENG: "Sms Users",
      FR: "Sms Users",
      TR: "Sms Users"
    },
    FB_USERS: {
      AR: "Fb Users",
      ENG: "Fb Users",
      FR: "Fb Users",
      TR: "Fb Users"
    },
    NEW_USERS: {
      AR: "New Users",
      ENG: "New Users",
      FR: "New Users",
      TR: "New Users"
    },

    TIME_FRAME: {
      AR: "Time Frame",
      ENG: "Time Frame",
      FR: "Time Frame",
      TR: "Time Frame"
    },

    DAILY_STATS: {
      AR: "Daily Stats",
      ENG: "Daily Stats",
      FR: "Daily Stats",
      TR: "Daily Stats"
    },
    REPORT_POOL_TABLE: {
      AR: "Report Pool Table",
      ENG: "Report Pool Table",
      FR: "Report Pool Table",
      TR: "Report Pool Table"
    },
    APPROVAL_POOL_TABLE: {
      AR: "Approval Pool Table",
      ENG: "Approval Pool Table",
      FR: "Approval Pool Table",
      TR: "Approval Pool Table"
    },
    INVESTIGATION_CASES_POOL_TABLE: {
      AR: "Investigation Cases Pool Table",
      ENG: "Investigation Cases Pool Table",
      FR: "Investigation Cases Pool Table",
      TR: "Investigation Cases Pool Table"
    },
    UNLINK_DEVICE: {
      AR: "Unlink Device",
      ENG: "Unlink Device",
      FR: "Unlink Device",
      TR: "Unlink Device"
    },
    INVESTIGATE: {
      AR: "Investigate",
      ENG: "Investigate",
      FR: "Investigate",
      TR: "Investigate"
    },
    ALREADY_EXISTING_VALUE: {
      AR: "Already Existing Value",
      ENG: "Already Existing Value",
      FR: "Already Existing Value",
      TR: "Already Existing Value"
    },
    SORRY_NO_PERMISSION: {
      AR: "Sorry No Permission",
      ENG: "Sorry No Permission",
      FR: "Sorry No Permission",
      TR: "Sorry No Permission"
    },
    SAVE: {
      AR: "Save",
      ENG: "Save",
      FR: "Save",
      TR: "Save"
    },
    EDIT: {
      AR: "Edit",
      ENG: "Edit",
      FR: "Edit",
      TR: "Edit"
    },
    DELETE: {
      AR: "Delete",
      ENG: "Delete",
      FR: "Delete",
      TR: "Delete"
    },

    HELPER: {
      AR: "Helper!",
      ENG: "Helper!",
      FR: "Helper!",
      TR: "Helper!"
    },
    EMPTY_STRING: {
      AR: "",
      ENG: "",
      FR: "",
      TR: ""
    },
    WELCOME: {
      AR: "Welcome",
      ENG: "Welcome",
      FR: "Welcome",
      TR: "Welcome"
    },
    PAYMENT_DATA_HELPER: {
      AR: "",
      ENG: `
      A. For IOS:

        - Some user purchases don't have ID linked to them, it will have the field userID: -99999
        - Apple doesn't return user country with purchase, thus it will have country code NO_COUNTRY


      B. IOS Event Types:

        - INITIAL_BUY: First Purchase
        - RENEWAL: Renewal of subscription
        - DID_RENEW: Renewal of subscription
        - DID_CHANGE_RENEWAL_PREF: Change subscription preference(upgrade or downgrade)
        - DID_CHANGE_RENEWAL_STATUS: Change auto renew status of subscription in the settings
        - INTERACTIVE_RENEWAL: when subscription expired, and user resubscribed
        - DID_FAIL_TO_RENEW: Renewal failed due to a biling issue; here user enters biling retry phase in apple servers
        - DID_RECOVER: When a user subscription auto renews successfully from retries after it failed due to billing issue and the issue was resolved
        - CANCEL: When apple refunds purchase to user
      

      C. Android Event Types: 

        - SUBSCRIP??TION_PURCHASED: First Purchase 
        - SUBSCRIPTION_RENEWED: Renewal of subscription
        - SUBSCRIPTION_ON_HOLD:  A subscription has entered account hold
        - SUBSCRIPTION_RECOVERED: A subscription was recovered from account hold.
        - SUBSCRIPTION_IN_GRACE_PERIOD: Subscription failed to renew, enters grace period while renewal is retried to check if billing issue fixed
        - SUBSCRIPTION_RESTARTED: User has restored their subscription from Play > Account > Subscriptions. The subscription was canceled but had not expired yet when the user restores. 
        - SUBSCRIPTION_PAUSED: subscription renewal was paused
        - SUBSCRIPTION_PAUSE_SCHEDULE_CHANGED: subscription renewal pause date changed
        - SUBSCRIPTION_EXPIRED: Subscription ended
        - SUBSCRIPTION_REVOKED: Subscription refuneded
        - SUBSCRIPTION_CANCELED: Subscription Renewal Cancelled
        - NO_PURCHASE_TYPE: SUBSCRIPTION_PAUSED or SUBSCRIPTION_PAUSE_SCHEDULE_CHANGED, due to issue in google, fixed in next releases
        
      `,
      FR: "",
      TR: ""
    },
    USER_NAME_CONDITIONS: {
      AR: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols",
      ENG: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols",
      FR: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols",
      TR: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols"
    },
    SAME_USER_NAME: {
      AR: "Enter New Username",
      ENG: "Enter New Username",
      FR: "Enter New Username",
      TR: "Enter New Username"
    },
    EVENTS_NOT_FOUND: {
      AR: "Events Not Found",
      ENG: "Events Not Found",
      FR: "Events Not Found",
      TR: "Events Not Found"
    },
    SESSION_EXPIRED: {
      AR: "Session Expired",
      ENG: "Session Expired",
      FR: "Session Expired",
      TR: "Session Expired"
    },
    USER_RATE_US_DATA_NOT_FOUND: {
      AR: "User Rate Us Data Not Found",
      ENG: "User Rate Us Data Not Found",
      FR: "User Rate Us Data Not Found",
      TR: "User Rate Us Data Not Found"
    },
    USER_RESET_SUCCESSFULLY: {
      AR: "User Reset Successfully",
      ENG: "User Reset Successfully",
      FR: "User Reset Successfully",
      TR: "User Reset Successfully"
    },
    DANGER_TO_PRESS: {
      AR: "Danger To press",
      ENG: "Danger To press",
      FR: "Danger To press",
      TR: "Danger To press"
    },
    PASSCODE: {
      AR: "Pass Code",
      ENG: "Pass Code",
      FR: "Pass Code",
      TR: "Pass Code"
    },
    ERROR: {
      AR: "ERROR",
      ENG: "ERROR",
      FR: "ERROR",
      TR: "ERROR"
    },
    OK: {
      AR: "OK",
      ENG: "OK",
      FR: "OK",
      TR: "OK"
    },
    ET3ERROR: {
      ENG: "ET3error OR Wrong Admin ID",
      AR: "ET3error OR Wrong Admin ID",
      FR: "ET3error OR Wrong Admin ID",
      TR: "ET3error OR Wrong Admin ID"
    },
    ROUTE_NOT_DEFINED: {
      ENG: "Route Not Defined",
      AR: "Route Not Defined",
      FR: "Route Not Defined",
      TR: "Route Not Defined"
    },
    INVALID_MISSING_ID_TYPE_NUMBER: {
      ENG: "Invalid or Missing id of type number",
      AR: "Invalid or Missing id of type number",
      FR: "Invalid or Missing id of type number",
      TR: "Invalid or Missing id of type number"
    },
    INVALID_PASSWORD_NUM: {
      ENG: "Invalid Password",
      AR: "Invalid Password",
      FR: "Invalid Password",
      TR: "Invalid Password"
    },
    INVALID_USER_ID: {
      ENG: "Invalid User ID",
      AR: "Invalid User ID",
      FR: "Invalid User ID",
      TR: "Invalid User ID"
    },
    INVALID_PLATFORM: {
      ENG: "Invalid Platform",
      AR: "Invalid Platform",
      FR: "Invalid Platform",
      TR: "Invalid Platform"
    },
    INVALID_CREDENTIALS_NUM: {
      ENG: "Invalid Credentials",
      AR: "Invalid Credentials",
      FR: "Invalid Credentials",
      TR: "Invalid Credentials"
    },
    INVALID_INPUT: {
      ENG: "Invalid Input",
      AR: "Invalid Input",
      FR: "Invalid Input",
      TR: "Invalid Input"
    },
    INVALID_EVENT_TYPE: {
      ENG: "Invalid Event type",
      AR: "Invalid Event type",
      FR: "Invalid Event type",
      TR: "Invalid Event type"
    },
    INVALID_STATUS: {
      ENG: "Invalid Status",
      AR: "Invalid Status",
      FR: "Invalid Status",
      TR: "Invalid Status"
    },
    INVALID_TIME_FRAME: {
      ENG: "Invalid Time Frame",
      AR: "Invalid Time Frame",
      FR: "Invalid Time Frame",
      TR: "Invalid Time Frame"
    },
    INVALID_COUNTRY: {
      ENG: "Invalid Country",
      AR: "Invalid Country",
      FR: "Invalid Country",
      TR: "Invalid Country"
    },
    APPROVAL_DATA_NOT_FOUND: {
      ENG: "Approval Data Not Found",
      AR: "Approval Data Not Found",
      FR: "Approval Data Not Found",
      TR: "Approval Data Not Found"
    },
    REPORTS_NOT_FOUND: {
      ENG: "Reports Not Found",
      AR: "Reports Not Found",
      FR: "Reports Not Found",
      TR: "Reports Not Found"
    },
    ACTIVITIES_NOT_FOUND: {
      ENG: "Activities Not Found",
      AR: "Activities Not Found",
      FR: "Activities Not Found",
      TR: "Activities Not Found"
    },
    NO_RESULT: {
      ENG: "No Result",
      AR: "No Result",
      FR: "No Result",
      TR: "No Result"
    },
    SERVER_ERROR_SHOWING_CONTACT: {
      ENG: "Server Error, if it keeps showing contact your team leader",
      AR: "Server Error, if it keeps showing contact your team leader",
      FR: "Server Error, if it keeps showing contact your team leader",
      TR: "Server Error, if it keeps showing contact your team leader"
    },
    USER_NOT_FOUND: {
      ENG: "User Not Found",
      AR: "User Not Found",
      FR: "User Not Found",
      TR: "User Not Found"
    },
    ADMIN_ID_REQUIRED: {
      ENG: "Admin Id Required",
      AR: "Admin Id Required",
      FR: "Admin Id Required",
      TR: "Admin Id Required"
    },
    ADMIN_NOT_FOUND: {
      ENG: "Admin Not Found",
      AR: "Admin Not Found",
      FR: "Admin Not Found",
      TR: "Admin Not Found"
    },
    NO_PERMISSION: {
      ENG: "No Permission",
      AR: "No Permission",
      FR: "No Permission",
      TR: "No Permission"
    },
    DEVICE_NOT_FOUND: {
      ENG: "Device Not Found",
      AR: "Device Not Found",
      FR: "Device Not Found",
      TR: "Device Not Found"
    },
    USER_LOGIN_NOT_FOUND: {
      ENG: "User Login Not Found",
      AR: "User Login Not Found",
      FR: "User Login Not Found",
      TR: "User Login Not Found"
    },
    PAYMENTS_NOT_FOUND: {
      ENG: "Payments Not Found",
      AR: "Payments Not Found",
      FR: "Payments Not Found",
      TR: "Payments Not Found"
    },
    TRANSACTION_NOT_FOUND: {
      ENG: "Transaction Not Found",
      AR: "Transaction Not Found",
      FR: "Transaction Not Found",
      TR: "Transaction Not Found"
    },
    MESSAGES_NOT_FOUND: {
      ENG: "Messages Not Found",
      AR: "Messages Not Found",
      FR: "Messages Not Found",
      TR: "Messages Not Found"
    },
    CONVERSATION_NOT_FOUND: {
      ENG: "Conversation Not Found",
      AR: "Conversation Not Found",
      FR: "Conversation Not Found",
      TR: "Conversation Not Found"
    },
    INCORRECT_PASSWORD: {
      ENG: "Incorrect Password",
      AR: "Incorrect Password",
      FR: "Incorrect Password",
      TR: "Incorrect Password"
    },
    NO_APPROVAL_DATA: {
      ENG: "No Approval Data",
      AR: "No Approval Data",
      FR: "No Approval Data",
      TR: "No Approval Data"
    },
    SOMETHING_WRONG: {
      ENG: "Something Wrong !!!",
      AR: "Something Wrong !!!",
      FR: "Something Wrong !!!",
      TR: "Something Wrong !!!"
    },
    CANNOT_CHANGE_STATUS_TO_ACTIVE: {
      ENG: "Cannot Change Status To active",
      AR: "Cannot Change Status To active",
      FR: "Cannot Change Status To active",
      TR: "Cannot Change Status To active"
    },
    POOL_ALREADY_EMPTY: {
      ENG: "Pool already empty",
      AR: "Pool already empty",
      FR: "Pool already empty",
      TR: "Pool already empty"
    },
    WRONGKEY: {
      ENG: "Wrong Key",
      AR: "Wrong Key",
      FR: "Wrong Key",
      TR: "Wrong Key"
    },
    WRONGBODYCOUNT: {
      ENG: "Wrong Body Count",
      AR: "Wrong Body Count",
      FR: "Wrong Body Count",
      TR: "Wrong Body Count"
    },
    REFERRAL_CODE_NOT_FOUND: {
      ENG: "Referral Code Not Found",
      AR: "Referral Code Not Found",
      FR: "Referral Code Not Found",
      TR: "Referral Code Not Found"
    },
    USER_HAS_NO_REFERRAL_CODE: {
      ENG: "User Has No Referral Code",
      AR: "User Has No Referral Code",
      FR: "User Has No Referral Code",
      TR: "User Has No Referral Code"
    },
    INVALID_TOKEN: {
      ENG: "Invalid Token",
      AR: "Invalid Token",
      FR: "Invalid Token",
      TR: "Invalid Token"
    },
    INVALID_USER_NAME: {
      ENG: "Invalid User Name",
      AR: "Invalid User Name",
      FR: "Invalid User Name",
      TR: "Invalid User Name"
    },

    PLEASE_SHARE_FACEBOOK: {
      ENG: "Please share with QA :  Cannot change user status because there is an active user with same facebook id",
      AR: "Please share with QA : Cannot change user status because there is an active user with same facebook id",
      FR: "Please share with QA : Cannot change user status because there is an active user with same facebook id",
      TR: "Please share with QA : Cannot change user status because there is an active user with same facebook id"
    },

    PLEASE_SHARE_NUMBER: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same phone number",
      AR: "Please share with QA : Cannot change user status because there is an active user with same phone number",
      FR: "Please share with QA : Cannot change user status because there is an active user with same phone number",
      TR: "Please share with QA : Cannot change user status because there is an active user with same phone number"
    },
    PLEASE_SHARE_DATA_TABLE: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same email in email data table",
      AR: "Please share with QA : Cannot change user status because there is an active user with same email in email data table",
      FR: "Please share with QA : Cannot change user status because there is an active user with same email in email data table",
      TR: "Please share with QA : Cannot change user status because there is an active user with same email in email data table"
    },
    PLEASE_SHARE_USERS_TABLE: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same email in users table ",
      AR: "Please share with QA : Cannot change user status because there is an active user with same email in users table",
      FR: "Please share with QA : Cannot change user status because there is an active user with same email in users table",
      TR: "Please share with QA : Cannot change user status because there is an active user with same email in users table"
    },
    PLEASE_SHARE_APPLE_ID: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same apple id ",
      AR: "Please share with QA : Cannot change user status because there is an active user with same apple id",
      FR: "Please share with QA : Cannot change user status because there is an active user with same apple id",
      TR: "Please share with QA : Cannot change user status because there is an active user with same apple id"
    },
    WATCH_ALERT_DASHBOARD: {
      AR: "Watch Alert Dashboard",
      ENG: "Watch Alert Dashboard",
      FR: "Watch Alert Dashboard",
      TR: "Watch Alert Dashboard"
    },
    USERS: {
      AR: "Users",
      ENG: "Users",
      FR: "Users",
      TR: "Users"
    },
    USERS_LOGIN: {
      AR: "Users LogIn",
      ENG: "Users LogIn",
      FR: "Users LogIn",
      TR: "Users LogIn"
    },
    USERS_PAYMENTS: {
      AR: "Users Payments",
      ENG: "Users Payments",
      FR: "Users Payments",
      TR: "Users Payments"
    },
    ADVANCED: {
      AR: "Advanced",
      ENG: "Advanced",
      FR: "Advanced",
      TR: "Advanced"
    },
    CONVERSATIONS: {
      AR: "Conversations",
      ENG: "Conversations",
      FR: "Conversations",
      TR: "Conversations"
    },
    EVENTS: {
      AR: "Events",
      ENG: "Events",
      FR: "Events",
      TR: "Events"
    },
    MESSAGES: {
      AR: "Messages",
      ENG: "Messages",
      FR: "Messages",
      TR: "Messages"
    },
    PAYMENTS: {
      AR: "Payments",
      ENG: "Payments",
      FR: "Payments",
      TR: "Payments"
    },
    PERMISSION: {
      AR: "Permission",
      ENG: "Permission",
      FR: " Permission",
      TR: "Permission"
    },
    RESET_PASSWORD: {
      AR: "Reset Password",
      ENG: "Reset Password",
      FR: "Reset Password",
      TR: "Reset Password"
    },
    RESET_ADMIN_PASSWORDS: {
      AR: "Reset Admin Passwords",
      ENG: "Reset Admin Passwords",
      FR: "Reset Admin Passwords",
      TR: "Reset Admin Passwords"
    },
    NEW_GENERATED_PASSWORD: {
      AR: "New Password: %EXTRA_DATA%",
      ENG: "New Password: %EXTRA_DATA%",
      FR: "New Password: %EXTRA_DATA%",
      TR: "New Password: %EXTRA_DATA%"
    },

    ALARMS: {
      AR: "Alarms",
      ENG: "Alarms",
      FR: " Alarms",
      TR: "Alarms"
    },
    PROMO_CODE_DESCRIPTION: {
      AR: "Code Description",
      ENG: "Code Description",
      FR: "Code Description",
      TR: "Code Description"
    },
    PROMO_CODE_START_DATE: {
      AR: "Code Start Date",
      ENG: "Code Start Date",
      FR: "Code Start Date",
      TR: "Code Start Date"
    },
    PROMO_CODE_EXPIRY_DATE: {
      AR: "Code Expiry Date",
      ENG: "Code Expiry Date",
      FR: "Code Expiry Date",
      TR: "Code Expiry Date"
    },
    PROMO_CODE_ACTIVE: {
      AR: "Code Is Active",
      ENG: "Code Is Active",
      FR: "Code Is Active",
      TR: "Code Is Active"
    },
    PROMO_CODE_VIP_MAX_USAGE: {
      AR: "Code Max Usage",
      ENG: "Code Max Usage",
      FR: "Code Max Usage",
      TR: "Code Max Usage"
    },
    PROMO_CODE_REWARD_IN_HOURS: {
      AR: "Reward In Hours",
      ENG: "Reward In Hours",
      FR: "Reward In Hours",
      TR: "Reward In Hours"
    },
    PROMO_CODE_NATIONALITY: {
      AR: "Code For Nationalities",
      ENG: "Code For Nationalities",
      FR: "Code For Nationalities",
      TR: "Code For Nationalities"
    },
    GENERATE: {
      AR: "Generate",
      ENG: "Generate",
      FR: "Generate",
      TR: "Generate"
    },
    PROMO_CODE_GENERATED_SUCCESSFULLY: {
      AR: "This promocode has been generated - Promocode Key %EXTRA_DATA%",
      ENG: "This promocode has been generated - Promocode Key %EXTRA_DATA%",
      FR: "This promocode has been generated - Promocode Key %EXTRA_DATA%",
      TR: "This promocode has been generated - Promocode Key %EXTRA_DATA%"
    },
    PROMO_CODES: {
      AR: "Promo codes ",
      ENG: "Promo codes ",
      FR: "Promo codes ",
      TR: "Promo codes "
    },
    PROMO_CODE_ID: {
      AR: "Promo code ID ",
      ENG: "Promo code ID",
      FR: "Promo code ID ",
      TR: "Promo code ID "
    },
    USER_PROMO_CODE_USAGE_TABLE: {
      ENG: "User Promo Code Usage Table",
      AR: "User Promo Code Usage Table",
      FR: "User Promo Code Usage Table",
      TR: "User Promo Code Usage Table"
    },
    ALL_PROMO_CODES: {
      ENG: "All Promo Codes ",
      AR: "All Promo Codes",
      FR: "All Promo Codes ",
      TR: "All Promo Codes "
    },
    UPDATE_PROMO_CODE: {
      ENG: "Update Promo Codes ",
      AR: "Update Promo Codes",
      FR: "Update Promo Codes ",
      TR: "Update Promo Codes "
    },
    PROMO_CODE_PAID: {
      ENG: "Code For Paid Users ",
      AR: "Code For Paid Users",
      FR: "Code For Paid Users ",
      TR: "Code For Paid Users "
    },
    PROMO_CODE_UPDATED_SUCCESSFULLY: {
      ENG: "Promo Code Updated Successfully ",
      AR: "Promo Code Updated Successfully",
      FR: "Promo Code Updated Successfully ",
      TR: "Promo Code Updated Successfully "
    },
    PROMO_STATUS_NOT_UPDATED_SUCCESSFULLY: {
      ENG: "The Current Status of the Code is same , change the status to complete ",
      AR: "The Current Status of the Code is same , change the status to complete",
      FR: "The Current Status of the Code is same , change the status to complete ",
      TR: "The Current Status of the Code is same , change the status to complete "
    },
    PROMO_CODE_IS_NO_UPDATED: {
      ENG: "Promo Code is not updated check you add the correct promocode and its correct id",
      AR: "Promo Code is not updated check you add the correct promocode and its correct id",
      FR: "Promo Code is not updated check you add the correct promocode and its correct id",
      TR: "Promo Code is not updated check you add the correct promocode and its correct id"
    },

    FLAGGED_CONNECTION: {
      ENG: "Flagged Connections",
      AR: "Flagged Connections",
      FR: "Flagged Connections",
      TR: "Flagged Connections"
    },

    FLAGGED_CONNECTION_APP: {
      ENG: "App Flagged Connections",
      AR: "App Flagged Connections",
      FR: "App Flagged Connections",
      TR: "App Flagged Connections"
    },
    FLAGGED_CONNECTION_WEB: {
      ENG: "Web Flagged Connections",
      AR: "Web Flagged Connections",
      FR: "Web Flagged Connections",
      TR: "Web Flagged Connections"
    },
    FLAGGED_CONNECTION_ADMIN: {
      ENG: "Admin Flagged Connections",
      AR: "Admin Flagged Connections",
      FR: "Admin Flagged Connections",
      TR: "Admin Flagged Connections"
    },
    USER_ID_PICTURE_REJECT: {
      ENG: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please ",
      AR: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please ",
      FR: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please ",
      TR: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please "
    },
    VIP_DETAILS: {
      ENG: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`,
      AR: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`,
      FR: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`,
      TR: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`
    },
    RATE_LIMIT: {
      ENG: "Rate Limit",
      AR: "Rate Limit",
      FR: "Rate Limit",
      TR: "Rate Limit"
    },
    ON_ALERT: {
      ENG: "Alert Mode",
      AR: "Alert Mode",
      FR: "Alert Mode",
      TR: "Alert Mode"
    },
    EMPTY_TBW_REASONS_DATA: {
      ENG: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!",
      AR: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!",
      FR: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!",
      TR: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!"
    },
    PROMOCODE_REWARD_IN_HOURS: {
      ENG: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`,
      AR: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`,
      FR: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`,
      TR: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`
    },
    PROMOCODE_NOT_SUPPORTED_FOR_GENDER: {
      ENG: `Reward doesn't exist for gender`,
      AR: `Reward doesn't exist for gender`,
      FR: `Reward doesn't exist for gender`,
      TR: `Reward doesn't exist for gender`
    },
    FLUSH_HOST_ALERT: {
      ENG: "make sure that email, password and passcode are set correctly",
      FR: "assurez-vous que l’adresse e-mail, le mot de passe et le mot de passe sont correctement définis",
      AR: "تأكد من تعيين البريد الإلكتروني وكلمة المرور ورمز المرور بشكل صحيح",
      TR: "e-posta, parola ve geçiş kodunun doğru ayarlandığından emin olun"
    },
    USER_ALBUM_PICTURES: {
      ENG: "User Pictures Album",
      AR: "User Pictures Album",
      FR: "User Pictures Album",
      TR: "User Pictures Album"
    },

    USERS_DATA: {
      ENG: "Users Data",
      AR: "Users Data",
      FR: "Users Data",
      TR: "Users Data"
    },
    USERS_PURCHASES_AND_SUBSCRIPTIONS: {
      ENG: "Users Purchase and Subscriptions",
      AR: "Users Purchase and Subscriptions",
      FR: "Users Purchase and Subscriptions",
      TR: "Users Purchase and Subscriptions"
    },
    USER_BREACHES_TABLE: {
      ENG: "User Breaches Tables",
      AR: "User Breaches Tables",
      FR: "User Breaches Tables",
      TR: "User Breaches Tables"
    },
    TB_DEACTIVATED_USER: {
      ENG: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!",
      AR: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!",
      FR: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!",
      TR: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!"
    },
    USER_NAME: {
      ENG: "User Name",
      AR: "User Name",
      FR: "User Name",
      TR: "User Name"
    },
    NATIONALITY: {
      ENG: "Nationality",
      AR: "Nationality",
      FR: "Nationality",
      TR: "Nationality"
    },
    COUNTRY_OF_RESIDENCE: {
      ENG: "Country of residence",
      AR: "Country of residence",
      FR: "Country of residence",
      TR: "Country of residence"
    },
    AGE: {
      ENG: "Age",
      AR: "Age",
      FR: "Age",
      TR: "Age"
    },
    HEIGHT: {
      ENG: "Height",
      AR: "Height",
      FR: "Height",
      TR: "Height"
    },
    WEIGHT: {
      ENG: "Weight",
      AR: "Weight",
      FR: "Weight",
      TR: "Weight"
    },
    USER_SEARCH_TYPE_REQUIRED: {
      ENG: "Wrong User Search Type",
      AR: "Wrong User Search Type",
      FR: "Wrong User Search Type",
      TR: "Wrong User Search Type"
    },
    USER_ALL_COMMENTS: {
      ENG: "All Comments :",
      AR: "All Comments :",
      FR: "All Comments :",
      TR: "All Comments :"
    },
    ADD_COMMENTS_POPUP_TEXT: {
      ENG: "Are you sure you want to leave this comment?",
      AR: "Are you sure you want to leave this comment?",
      FR: "Are you sure you want to leave this comment?",
      TR: "Are you sure you want to leave this comment?"
    },
    ADD_RESET_ACCOUNT_POPUP_TEXT: {
      ENG: "Are you sure you want to reset your account?",
      AR: "Are you sure you want to reset your account?",
      TR: "Are you sure you want to reset your account?",
      FR: "Are you sure you want to reset your account?"
    },
    ADD_COMMENT: {
      ENG: "Add Comment",
      AR: "Add Comment",
      FR: "Add Comment",
      TR: "Add Comment"
    },
    EMPTY_COMMENT: {
      ENG: "Empty Comment",
      AR: "Empty Comment",
      FR: "Empty Comment",
      TR: "Empty Comment"
    },

    UNDER_CSR_INVESTIGATION_STATUS: {
      ENG: "Under CSR Investigation",
      AR: "Under CSR Investigation",
      FR: "Under CSR Investigation",
      TR: "Under CSR Investigation"
    },
    INVESTIGATION_CASES_NOT_FOUND: {
      ENG: "Investigation Cases not found!",
      AR: "Investigation Cases not found!",
      FR: "Investigation Cases not found!",
      TR: "Investigation Cases not found!"
    },
    DESCRIPTION_ABOUT_ME: {
      ENG: "About Me",
      AR: "About Me",
      FR: "About Me",
      TR: "About Me"
    },
    DESCRIPTION_ABOUT_MY_PARTNER: {
      ENG: "About my Partner",
      AR: "About my Partner",
      FR: "About my Partner",
      TR: "About my Partner"
    },

    VIEW_ACCOUNTS_DELETION_DATA: {
      ENG: "View Accounts Deletion data",
      AR: "View Accounts Deletion data",
      FR: "View Accounts Deletion data",
      TR: "View Accounts Deletion data"
    },
    ACCOUNT_DELETION_HELPER_TEXT: {
      ENG: "This page displays data on the users deleted accounts for analysis.",
      AR: "This page displays data on the users deleted accounts for analysis.",
      FR: "This page displays data on the users deleted accounts for analysis.",
      TR: "This page displays data on the users deleted accounts for analysis."
    },
    ACCOUNTS_DELETION_DATA: {
      ENG: "Accounts Deletion data",
      AR: "Accounts Deletion data",
      FR: "Accounts Deletion data",
      TR: "Accounts Deletion data"
    },
    FOUND_PARTNER_OUTSIDE_ET3ARRAF: {
      ENG: "Found my soulmate out of the app",
      AR: "Found my soulmate out of the app",
      FR: "Found my soulmate out of the app",
      TR: "Found my soulmate out of the app"
    },
    NOT_AS_EXPECTED: {
      ENG: "Different expectations",
      AR: "Different expectations",
      FR: "Different expectations",
      TR: "Different expectations"
    },
    OTHER_REASONS: {
      ENG: "Other reasons",
      AR: "Other reasons",
      FR: "Other reasons",
      TR: "Other reasons"
    },
    ER3ARRAF_IS_HARD_TO_USE: {
      ENG: "Difficulty of use",
      AR: "Difficulty of use",
      FR: "Difficulty of use",
      TR: "Difficulty of use"
    },
    NOT_ABLE_TO_FIND_PARTNER: {
      ENG: "I didn't find good matches",
      AR: "I didn't find good matches",
      FR: "I didn't find good matches",
      TR: "I didn't find good matches"
    },
    FOUND_PARTNER_THROUGH_ET3ARRAF: {
      ENG: "Found my soulmate on the app",
      AR: "Found my soulmate on the app",
      FR: "Found my soulmate on the app",
      TR: "Found my soulmate on the app"
    },
    ACCOUNTS_DELETION_DATA_NOT_FOUND: {
      ENG: "Deleted Accounts Data has been not found!",
      AR: "Deleted Accounts Data has been not found!",
      FR: "Deleted Accounts Data has been not found!",
      TR: "Deleted Accounts Data has been not found!"
    },
    USER_ALREADY_UNDER_CSR_INVESTIGATION: {
      ENG: "User Already Under Csr Investigation!",
      AR: "User Already Under Csr Investigation!",
      FR: "User Already Under Csr Investigation!",
      TR: "User Already Under Csr Investigation!"
    },
    REPORT_NOT_FOUND: {
      ENG: "Report Not Found, Please press 'Get Reports'",
      AR: "Report Not Found, Please press 'Get Reports'",
      FR: "Report Not Found, Please press 'Get Reports'",
      TR: "Report Not Found, Please press 'Get Reports'"
    },
    USER_STATUS_DATE: {
      ENG: "user status Date",
      AR: "user status Date",
      FR: "user status Date",
      TR: "user status Date"
    },
    USER_EMAIL_SUBSCRIPTION: {
      ENG: "user email subscription status",
      AR: "user email subscription status",
      FR: "user email subscription status",
      TR: "user email subscription status"
    },
    USER_STATUS: {
      ENG: "User Status :",
      AR: "User Status :",
      FR: "User Status :",
      TR: "User Status :"
    },
    QA_NEW_STATUS_DATE: {
      ENG: "Status New Date",
      AR: "Status New Date",
      FR: "Status New Date",
      TR: "Status New Date"
    },
    QA_CHANGE_STATUS_DATE: {
      ENG: "Change Date",
      AR: "Change Date",
      FR: "Change Date",
      TR: "Change Date"
    },
    SUBSCRIBE: {
      ENG: "Subscribe",
      AR: "Subscribe",
      FR: "Subscribe",
      TR: "Subscribe"
    },
    UNSUBSCRIBE: {
      ENG: "Unsubscribe",
      AR: "Unsubscribe",
      FR: "Unsubscribe",
      TR: "Unsubscribe"
    },
    UPDATING_TO_VERSION: {
      ENG: "Updating to version ",
      AR: "Updating to version ",
      FR: "Updating to version ",
      TR: "Updating to version "
    },

    EXPORT_TO_CSV_FILE: {
      ENG: "CSV",
      AR: "CSV",
      FR: "CSV",
      TR: "CSV"
    },

    PEER_DESCRIPTION_ACTION_ALREADY_DONE: {
      ENG: "Action On Peer Description Already Done, Please press 'Get'",
      AR: "Action On Peer Description Already Done, Please press 'Get'",
      FR: "Action On Peer Description Already Done, Please press 'Get'",
      TR: "Action On Peer Description Already Done, Please press 'Get'"
    },
    PICTURE_ACTION_ALREADY_DONE: {
      ENG: "Action On Album Picture Already Done, Please press 'Get'",
      AR: "Action On Album Picture Already Done, Please press 'Get'",
      FR: "Action On Album Picture Already Done, Please press 'Get'",
      TR: "Action On Album Picture Already Done, Please press 'Get'"
    },

    DESCRIPTION_ACTION_ALREADY_DONE: {
      ENG: "Action On Description Already Done, Please press 'Get'",
      AR: "Action On Description Already Done, Please press 'Get'",
      FR: "Action On Description Already Done, Please press 'Get'",
      TR: "Action On Description Already Done, Please press 'Get'"
    },
    TURN_OFF_FEATURES: {
      ENG: "Turn Off Features",
      AR: "Turn Off Features",
      FR: "Turn Off Features",
      TR: "Turn Off Features"
    },
    FEATURES: {
      ENG: "Features",
      AR: "Features",
      FR: "Features",
      TR: "Features"
    },
    KHATTABAT_CAPACITY: {
      ENG: "Khattabat capacity",
      AR: "Khattabat capacity",
      FR: "Khattabat capacity",
      TR: "Khattabat capacity"
    },
    FEATURE_OFF: {
      ENG: "Turn OFF",
      AR: "Turn OFF",
      FR: "Turn OFF",
      TR: "Turn OFF"
    },
    FEATURE_ON: {
      ENG: "Turn ON",
      AR: "Turn ON",
      FR: "Turn ON",
      TR: "Turn ON"
    },

    ALARMS_NOT_FOUND: {
      AR: "Alarms Not Found",
      ENG: "Alarms Not Found",
      FR: "Alarms Not Found",
      TR: "Alarms Not Found"
    },

    MESSAGE_TYPE: {
      ENG: "Message Type",
      AR: "Message Type",
      FR: "Message Type",
      TR: "Message Type"
    },
    LIMIT_BY_REPORTED: {
      ENG: "Limit by Reported",
      AR: "Limit by Reported",
      FR: "Limit by Reported",
      TR: "Limit by Reported"
    },
    PROMO_CODE_KEY: {
      ENG: "Promo Code Key",
      AR: "Promo Code Key",
      FR: "Promo Code Key",
      TR: "Promo Code Key"
    },
    INVALID_PROMO_CODE_KEY: {
      ENG: "Invalid Promo Code Key ",
      AR: "Invalid Promo Code Key",
      FR: "Invalid Promo Code Key ",
      TR: "Invalid Promo Code Key "
    },
    PROMO_CODE_ALREADY_EXISTS: {
      ENG: "Promo Code Already Found",
      AR: "Promo Code Already Found",
      FR: "Promo Code Already Found",
      TR: "Promo Code Already Found"
    },

    AUDIT_EVENTS_POOL_TABLE: {
      AR: "Audit Events Pool Table",
      ENG: "Audit Events Pool Table",
      FR: "Audit Events Pool Table",
      TR: "Audit Events Pool Table"
    },

    IOS_RECEIPT_TOKEN_DATA: {
      ENG: "Ios Receipt Token Data",
      AR: "Ios Receipt Token Data",
      FR: "Ios Receipt Token Data",
      TR: "Ios Receipt Token Data"
    },
    SAFE: {
      ENG: "Safe",
      AR: "Safe",
      FR: "Safe",
      TR: "Safe"
    },
    DESCRIPTION_CHANGED: {
      ENG: "Description Changed From user on APP, please press Get",
      AR: "Description Changed From user on APP, please press Get",
      FR: "Description Changed From user on APP, please press Get",
      TR: "Description Changed From user on APP, please press Get"
    },
    INVESTIGATION_CASE_ALREADY_RESOLVED: {
      ENG: "Investigation Case is already resolved or on other admin pool",
      AR: "Investigation Case is already resolved or on other admin pool",
      FR: "Investigation Case is already resolved or on other admin pool",
      TR: "Investigation Case is already resolved or on other admin pool"
    },
    INVESTIGATION_CASE_EXITS_IN_SOME_POOL: {
      ENG: "The investigation case is already in a pool",
      AR: "The investigation case is already in a pool",
      FR: "The investigation case is already in a pool",
      TR: "The investigation case is already in a pool"
    },
    REPORT_CASE_EXISTS_IN_SOME_POOL: {
      ENG: "The report case is already in a pool",
      AR: "The report case is already in a pool",
      FR: "The report case is already in a pool",
      TR: "The report case is already in a pool"
    },
    REPORT_CASES_ALREADY_RESOLVED: {
      ENG: "Report Cases are already resolved",
      AR: "Report Cases are already resolved",
      FR: "Report Cases are already resolved",
      TR: "Report Cases are already resolved"
    },
    USER_SHOULD_BE_VERIFIED: {
      ENG: "User needs to verify their account",
      AR: "User needs to verify their account",
      FR: "User needs to verify their account",
      TR: "User needs to verify their account"
    },
    SOCIAL_MEDIA_ACCOUNT: {
      ENG: "Social Media:",
      AR: "Social Media:",
      FR: "Social Media:",
      TR: "Social Media:"
    },
    BAD_WORDS: {
      ENG: "Bad Words:",
      AR: "Bad Words:",
      FR: "Bad Words:",
      TR: "Bad Words:"
    },
    GET_USER_BANNED: {
      ENG: "Get user banned",
      AR: "Get user banned",
      FR: "Get user banned",
      TR: "Get user banned"
    },
    FLAGGED_DESCRIPTION_EMPTY_TABLE: {
      ENG: "Flagged Description Table Is Empty",
      AR: "Flagged Description Table Is Empty",
      FR: "Flagged Description Table Is Empty",
      TR: "Flagged Description Table Is Empty"
    },
    NO_BANNED_USERS: {
      ENG: "No Banned Users",
      AR: "No Banned Users",
      FR: "No Banned Users",
      TR: "No Banned Users"
    },
    SUBMIT: {
      ENG: "Submit",
      AR: "Submit",
      FR: "Submit",
      TR: "Submit"
    },
    ADD_DESCRIPTION: {
      ENG: "Add Input Description",
      AR: "Add Input Description",
      FR: "Add Input Description",
      TR: "Add Input Description"
    },
    DESCRIPTION_ADDED: {
      ENG: "Description Added",
      AR: "Description Added",
      FR: "Description Added",
      TR: "Description Added"
    },
    DESCRIPTION_DELETED: {
      ENG: "Description Deleted",
      AR: "Description Deleted",
      FR: "Description Deleted",
      TR: "Description Deleted"
    },
    ADD_FLAGGED_DESCRIPTION_INVALID_INPUT: {
      ENG: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100).",
      AR: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100).",
      FR: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100).",
      TR: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100)."
    },
    PLEASE_CONTACT_SE: {
      ENG: "Please contact SE department",
      AR: "Please contact SE department",
      FR: "Please contact SE department",
      TR: "Please contact SE department"
    },
    TOTAL_USERS: {
      ENG: "Total Users",
      AR: "Total Users",
      FR: "Total Users",
      TR: "Total Users"
    },
    TOTAL_CONVERSATIONS: {
      ENG: "Total Conversations",
      AR: "Total Conversations",
      FR: "Total Conversations",
      TR: "Total Conversations"
    },
    NEW_CONVERSATIONS: {
      ENG: "New Conversations",
      AR: "New Conversations",
      FR: "New Conversations",
      TR: "New Conversations"
    },
    TOTAL_MESSAGES: {
      ENG: "Total Messages",
      AR: "Total Messages",
      TR: "Total Messages",
      FR: "Total Messages"
    },
    NEW_MESSAGES: {
      ENG: "New Messages",
      AR: "New Messages",
      FR: "New Messages",
      TR: "New Messages"
    },
    SALES_USD: {
      ENG: "Sales (USD)",
      AR: "Sales (USD)",
      FR: "Sales (USD)",
      TR: "Sales (USD)"
    },
    MARKETING_EXPENSES_USD: {
      ENG: "Marketing Expenses (USD)",
      AR: "Marketing Expenses (USD)",
      FR: "Marketing Expenses (USD)",
      TR: "Marketing Expenses (USD)"
    },
    NO_CLEAN_POOL_DATA: {
      AR: "No pool was found, already cleaned",
      ENG: "No pool was found, already cleaned",
      FR: "No pool was found, already cleaned",
      TR: "No pool was found, already cleaned"
    },
    NO_MORE_MESSAGES: {
      AR: "No more messages",
      ENG: "No more messages",
      FR: "No more messages",
      TR: "No more messages"
    },
    KHATTABA_NAME: {
      AR: "Name ",
      ENG: "Name ",
      FR: "Name ",
      TR: "Name "
    },
    KHATTABA_CATEGORY: {
      AR: "Category ",
      ENG: "Category ",
      FR: "Category ",
      TR: "Category "
    },
    KHATTABA_PRICE: {
      AR: "Price ",
      ENG: "Price ",
      FR: "Price ",
      TR: "Price "
    },
    KHATTABA_DESCRIPTION: {
      AR: "Description ",
      ENG: "Description ",
      FR: "Description ",
      TR: "Description "
    },
    KHATTABA_LANGUAGE: {
      AR: "Language ",
      ENG: "Language ",
      FR: "Language ",
      TR: "Language "
    },
    KHATTABA_AGE: {
      AR: "Age ",
      ENG: "Age ",
      FR: "Age ",
      TR: "Age "
    },
    KHATTABA_LOCATION: {
      AR: "Location",
      ENG: "Location",
      FR: "Location",
      TR: "Location"
    },
    KHATTABA_CURRENCY: {
      AR: "Currency",
      ENG: "Currency",
      FR: "Currency",
      TR: "Currency"
    },
    LOCATION_FIELD: {
      AR: "My Location Field",
      ENG: "My Location Field",
      FR: "My Location Field",
      TR: "My Location Field"
    },
    CURRENCY_I_WORK_WITH: {
      AR: "Currency I Work With",
      ENG: "Currency I Work With",
      FR: "Currency I Work With",
      TR: "Currency I Work With"
    },
    MY_ID_TO_CONNECT: {
      AR: "My ID To Connect",
      ENG: "My ID To Connect",
      FR: "My ID To Connect",
      TR: "My ID To Connect"
    },
    "PRICE/EACH PRIDE": {
      AR: "My Price/Each Pride",
      ENG: "My Price/Each Pride",
      FR: "My Price/Each Pride",
      TR: "My Price/Each Pride"
    },
    MORE_INFO_KHATTABAT: {
      AR: "Click here for more info",
      ENG: "Click here for more info",
      FR: "Click here for more info",
      TR: "Click here for more info"
    },
    HELLO_MESSAGE: {
      ENG: "Hello %EXTRA_DATA_0% 👋🏻 this is %EXTRA_DATA_1% Also Known As Em Noura, I am %EXTRA_DATA_2% years old and Currently based in Lebanon %EXTRA_DATA_3%. I'm here to connect you with our beautiful Prides that are searching for their dream man and help you find your future partner and here's a little description about me %EXTRA_DATA_4% and I talk only in %EXTRA_DATA_5% Language",
      AR: "مرحبا %EXTRA_DATA_0% 👋🏻 هذا %EXTRA_DATA_1% المعروفة أيضًا باسم إم نورا، عمري %EXTRA_DATA_2% عامًا وأنا مقيمة حاليًا في لبنان %EXTRA_DATA_3%. أنا هنا لربطك بالعرائس الجميلات اللواتي يبحثن عن رجل أحلامهن ومساعدتك في العثور على شريكك المستقبلي وهنا وصف قصير عني %EXTRA_DATA_4% وأتحدث فقط باللغة %EXTRA_DATA_5%",
      FR: "Bonjour %EXTRA_DATA_0% 👋🏻 c'est %EXTRA_DATA_1% également connue sous le nom d'Em Noura, j'ai %EXTRA_DATA_2% ans et je suis actuellement basée au Liban %EXTRA_DATA_3%. Je suis ici pour vous connecter avec nos belles mariées qui cherchent leur homme idéal et vous aider à trouver votre futur partenaire et voici une petite description de moi %EXTRA_DATA_4% et je parle seulement en %EXTRA_DATA_5% Langue",
      TR: "Merhaba %EXTRA_DATA_0% 👋🏻 bu %EXTRA_DATA_1% Ayrıca Em Noura olarak da bilinir, %EXTRA_DATA_2% yaşındayım ve şu anda Lübnan'da yaşıyorum %EXTRA_DATA_3%. Burada sizleri hayallerindeki erkeklerini arayan güzel gelinlerimizle bağlantı kurmak ve gelecekteki partnerinizi bulmanıza yardımcı olmak için buradayım ve işte benim hakkımda küçük bir açıklama %EXTRA_DATA_4% ve sadece %EXTRA_DATA_5% Dilinde konuşuyorum"
    },
    KHATTABAT: {
      ENG: "Khattabat",
      AR: "Khattabat",
      FR: "Khattabat",
      TR: "Khattabat"
    },
    MALE_CLIENTS: {
      ENG: "Male Clients",
      AR: "Male Clients",
      FR: "Male Clients",
      TR: "Male Clients"
    },
    FEMALE_CLIENTS: {
      ENG: "Female Clients",
      AR: "Female Clients",
      FR: "Female Clients",
      TR: "Female Clients"
    },
    MATCHMAKING: {
      ENG: "Matchmaking",
      AR: "Matchmaking",
      FR: "Matchmaking",
      TR: "Matchmaking"
    },
    KHATTABAT_MATCHING_SEARCH_AND_1O1M: {
      ENG: "Search & 101M",
      AR: "Search & 101M",
      FR: "Search & 101M",
      TR: "Search & 101M"
    },
    KHATTABAT_MATCHING_RESULTS: {
      ENG: "Results 101M",
      AR: "Results 101M",
      FR: "Results 101M",
      TR: "Results 101M"
    },
    CLIENT_IGNORE: {
      ENG: "Ignore",
      AR: "Ignore",
      FR: "Ignore",
      TR: "Ignore"
    },
    CLIENT_PAID: {
      ENG: "Paid",
      AR: "Paid",
      FR: "Paid",
      TR: "Paid"
    },
    CLIENT_LEAD: {
      ENG: "Lead",
      AR: "Lead",
      FR: "Lead",
      TR: "Lead"
    },
    CLIENT_CONTACTED: {
      ENG: "Contacted",
      AR: "Contacted",
      FR: "Contacted",
      TR: "Contacted"
    },
    CLIENT_NEW_CONTACT: {
      ENG: "New Contacts",
      AR: "New Contacts",
      FR: "New Contacts",
      TR: "New Contacts"
    },
    SUBSCRIPTION_ACTIVE: {
      ENG: "Sub Ac",
      AR: "Sub Ac",
      FR: "Sub Ac",
      TR: "Sub Ac"
    },
    SUBSCRIPTION_EXPIRED: {
      ENG: "Sub Ex",
      AR: "Sub Ex",
      FR: "Sub Ex",
      TR: "Sub Ex"
    },
    GET_KHATTABAT_CLIENTS: {
      ENG: "Get Khatabat Clients",
      AR: "Get Khatabat Clients",
      FR: "Get Khatabat Clients",
      TR: "Get Khatabat Clients"
    },
    SEND: {
      AR: "Send",
      ENG: "Send",
      FR: "Send",
      TR: "Send"
    },
    ADD: {
      AR: "Add",
      ENG: "Add",
      FR: "Add",
      TR: "Add"
    },
    BLOCK: {
      AR: "Block",
      ENG: "Block",
      FR: "Block",
      TR: "Block"
    },
    CREATE_ONE_O_TWO: {
      AR: "Create 1O2",
      ENG: "Create 1O2",
      FR: "Create 1O2",
      TR: "Create 1O2"
    },
    ONE_O_ONE_C: {
      AR: "1O1C",
      ENG: "1O1C",
      FR: "1O1C",
      TR: "1O1C"
    },
    HIGHLIGHT: {
      AR: "Highlight",
      ENG: "Highlight",
      FR: "Highlight",
      TR: "Highlight"
    },
    SLACK_ALERTS: {
      AR: "Slack alerts",
      ENG: "Slack alerts",
      FR: "Slack alerts",
      TR: "Slack alerts"
    },
    ONE_O_TWO_WITH: {
      AR: "1O2 With",
      ENG: "1O2 With",
      FR: "1O2 With",
      TR: "1O2 With"
    },
    COMMENTS: {
      AR: "Comments",
      ENG: "Comments",
      FR: "Comments",
      TR: "Comments"
    },
    ONGOING: {
      AR: "Ongoing",
      ENG: "Ongoing",
      FR: "Ongoing",
      TR: "Ongoing"
    },
    EXITED_BY_MATCH: {
      AR: "Exited by match",
      ENG: "Exited by match",
      FR: "Exited by match",
      TR: "Exited by match"
    },
    EXITED_BY_CLIENT: {
      AR: "Exited by client",
      ENG: "Exited by client",
      FR: "Exited by client",
      TR: "Exited by client"
    },
    PENDING_INTERACTION: {
      AR: "Pending Interaction",
      ENG: "Pending Interaction",
      FR: "Pending Interaction",
      TR: "Pending Interaction"
    },
    ONE_O_ONE_M: {
      ENG: "OneOOneM",
      AR: "OneOOneM",
      FR: "OneOOneM",
      TR: "OneOOneM"
    },

    MATCH_IDS: {
      ENG: "MatchIDs",
      AR: "MatchIDs",
      FR: "MatchIDs",
      TR: "MatchIDs"
    },
    CLIENT_ID: {
      ENG: "ClientID",
      AR: "ClientID",
      FR: "ClientID",
      TR: "ClientID"
    },

    ONE_O_ONE_M_SENT_RESULT: {
      ENG: "OneOOneM Sent result \n %EXTRA_DATA%",
      AR: "OneOOneM Sent result \n %EXTRA_DATA%",
      FR: "OneOOneM Sent result \n %EXTRA_DATA%",
      TR: "OneOOneM Sent result \n %EXTRA_DATA%"
    },
    INCORRECT_CLIENT_ID: {
      ENG: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba",
      AR: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba",
      FR: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba",
      TR: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba"
    },
    REFUND: {
      AR: "Refund",
      ENG: "Refund",
      FR: "Refund",
      TR: "Refund"
    },
    CANCEL: {
      AR: "Cancel",
      ENG: "Cancel",
      FR: "Cancel",
      TR: "Cancel"
    },
    NOT_UPDATED_CHECK_IF_CORRECT_PAYEMTN_INTENT: {
      AR: "Not Updated Check If Correct Payment Intent",
      ENG: "Not Updated Check If Correct Payment Intent",
      FR: "Not Updated Check If Correct Payment Intent",
      TR: "Not Updated Check If Correct Payment Intent"
    },
    NOT_UPDATED_CHECK_IF_CORRECT_SUBSCRIPTION: {
      AR: "Not Updated Check If Correct Subscription",
      ENG: "Not Updated Check If Correct Subscription",
      TR: "Not Updated Check If Correct Subscription",
      FR: "Not Updated Check If Correct Subscription"
    },
    ONE_O_TWO_CLIENT_MATCH_SAME_GENDER: {
      ENG: "Client and Match have same Gender for this One O Two conversation!!",
      AR: "Client and Match have same Gender for this One O Two conversation!!",
      FR: "Client and Match have same Gender for this One O Two conversation!!",
      TR: "Client and Match have same Gender for this One O Two conversation!!"
    },
    CANNOT_CHANGE_TO_SAME_STATUS: {
      AR: "Cannot change to same user status, please press Get",
      ENG: "Cannot change to same user status, please press Get",
      FR: "Cannot change to same user status, please press Get",
      TR: "Cannot change to same user status, please press Get"
    },
    USER_DOES_NOT_EXIST_OR_INACTIVE: {
      ENG: "User does not exist or inactive",
      AR: "User does not exist or inactive",
      FR: "User does not exist or inactive",
      TR: "User does not exist or inactive"
    },
    ONE_O_TWO_CONVERSATION_ALREADY_CREATED: {
      ENG: "1O2 conversation already created!",
      AR: "1O2 conversation already created!",
      FR: "1O2 conversation already created!",
      TR: "1O2 conversation already created!"
    },
    RECEIPT_ORIGINAL_TRANSACTION_ID: {
      ENG: "Receipt Original Transaction ID",
      AR: "Receipt Original Transaction ID",
      FR: "Receipt Original Transaction ID",
      TR: "Receipt Original Transaction ID"
    },
    RECEIPT_PURCHASE_DATE: {
      ENG: "Purchase Date",
      AR: "Purchase Date",
      FR: "Purchase Date",
      TR: "Purchase Date"
    },
    RECEIPT_EXPIRES_DATE: {
      ENG: "Expires Date",
      AR: "Expires Date",
      FR: "Expires Date",
      TR: "Expires Date"
    },

    RECEIPT_IN_APP_OWNERSHIP_TYPE: {
      ENG: "Status",
      AR: "Status",
      FR: "Status",
      TR: "Status"
    },
    RECEIPT_QUANTITY: {
      ENG: "Quantity",
      AR: "Quantity",
      FR: "Quantity",
      TR: "Quantity"
    },
    RECEIPT_EXPIRES_DATE_MS: {
      ENG: "Expires Date Ms",
      AR: "Expires Date Ms",
      FR: "Expires Date Ms",
      TR: "Expires Date Ms"
    },
    RECEIPT_EXPIRES_DATE_PST: {
      ENG: "Expires Date Pst",
      AR: "Expires Date Pst",
      FR: "Expires Date Pst",
      TR: "Expires Date Pst"
    },
    RECEIPT_PURCHASE_DATE_MS: {
      ENG: "Purchase Date Ms",
      AR: "Purchase Date Ms",
      FR: "Purchase Date Ms",
      TR: "Purchase Date Ms"
    },
    RECEIPT_PURCHASE_DATE_PST: {
      ENG: "Purchase Date Pst",
      AR: "Purchase Date Pst",
      FR: "Purchase Date Pst",
      TR: "Purchase Date Pst"
    },
    RECEIPT_ORIGINAL_PURCHASE_DATE: {
      ENG: "Original Purchase Date",
      AR: "Original Purchase Date",
      FR: "Original Purchase Date",
      TR: "Original Purchase Date"
    },
    RECEIPT_ORIGINAL_PURCHASE_MS: {
      ENG: "Original Purchase Date Ms",
      AR: "Original Purchase Date Ms",
      FR: "Original Purchase Date Ms",
      TR: "Original Purchase Date Ms"
    },
    RECEIPT_ORIGINAL_PURCHASE_DATE_PST: {
      ENG: "Original Purchase Date Pst",
      AR: "Original Purchase Date Pst",
      FR: "Original Purchase Date Pst",
      TR: "Original Purchase Date Pst"
    },
    RECEIPT_WEB_ORDER_LINE_ITEM_ID: {
      ENG: "Web Order Line Item Id",
      AR: "Web Order Line Item Id",
      FR: "Web Order Line Item Id",
      TR: "Web Order Line Item Id"
    },
    RECEIPT_IS_IN_INTRO_OFFER_PERIOD: {
      ENG: "Is In Intro Offer Period",
      AR: "Is In Intro Offer Period",
      FR: "Is In Intro Offer Period",
      TR: "Is In Intro Offer Period"
    },
    RECEIPT_IS_TRIAL_PERIOD: {
      ENG: "Is Trial Period",
      AR: "Is Trial Period",
      FR: "Is Trial Period",
      TR: "Is Trial Period"
    },
    RECEIPT_APP_ACCOUNT_TOKEN: {
      ENG: "App Account Token",
      AR: "App Account Token",
      FR: "App Account Token",
      TR: "App Account Token"
    },
    RECEIPT_HAS_PENDING: {
      ENG: "Has Pending",
      AR: "Has Pending",
      FR: "Has Pending",
      TR: "Has Pending"
    },
    RECEIPT_IS_IN_BILLING_RETRY: {
      ENG: "Is In Billing Retry",
      AR: "Is In Billing Retry",
      FR: "Is In Billing Retry",
      TR: "Is In Billing Retry"
    },
    LAST_RECEIPT_ORIGINAL_TRANSACTION_ID: {
      ENG: "Original Transaction Id",
      AR: "Original Transaction Id",
      FR: "Original Transaction Id",
      TR: "Original Transaction Id"
    },
    RECEIPT_PRODUCT_ID: {
      ENG: "Product Id",
      AR: "Product Id",
      FR: "Product Id",
      TR: "Product Id"
    },
    LAST_RECEIPT_PRODUCT_ID: {
      ENG: "Product Id",
      AR: "Product Id",
      FR: "Product Id",
      TR: "Product Id"
    },
    RECEIPT_EXPIRATION_INTENT: {
      ENG: "Expiration Intent",
      AR: "Expiration Intent",
      FR: "Expiration Intent",
      TR: "Expiration Intent"
    },
    RECEIPT_AUTO_RENEW_STATUS: {
      ENG: "Auto Renew Status",
      AR: "Auto Renew Status",
      FR: "Auto Renew Status",
      TR: "Auto Renew Status"
    },
    RECEIPT_AUTO_RENEW_PRODUCT_ID: {
      ENG: "Auto Renew Product Id",
      AR: "Auto Renew Product Id",
      FR: "Auto Renew Product Id",
      TR: "Auto Renew Product Id"
    },
    LAST_RECEIPT: {
      ENG: "Last Receipt",
      AR: "Last Receipt",
      FR: "Last Receipt",
      TR: "Last Receipt"
    },
    PENDING_RECEIPTS: {
      ENG: "Pending Receipts",
      AR: "Pending Receipts",
      FR: "Pending Receipts",
      TR: "Pending Receipts"
    },
    NO_RECEIPT: {
      ENG: "No Receipt",
      AR: "No Receipt",
      FR: "No Receipt",
      TR: "No Receipt"
    },
    APPLE_RECEIPT_ERROR: {
      ENG: "Apple Receipt Error",
      AR: "Apple Receipt Error",
      FR: "Apple Receipt Error",
      TR: "Apple Receipt Error"
    },
    ANDROID_RECEIPT_ERROR: {
      ENG: "Android Receipt Error",
      AR: "Android Receipt Error",
      FR: "Android Receipt Error",
      TR: "Android Receipt Error"
    },
    NO_RECEIPT_TOKEN_FOUND: {
      ENG: "No Receipt Token Found",
      AR: "No Receipt Token Found",
      FR: "No Receipt Token Found",
      TR: "No Receipt Token Found"
    },
    ALREADY_CANCELLED: {
      AR: "Already Cancelled",
      ENG: "Already Cancelled",
      FR: "Already Cancelled",
      TR: "Already Cancelled"
    },
    CANCELLED: {
      AR: "Cancelled",
      ENG: "Cancelled",
      FR: "Cancelled",
      TR: "Cancelled"
    },
    ONE_O_TWO_CONVERSATION_IS_NOT_ACTIVE_ANYMORE: {
      ENG: "ONE O TWO Conversation is not active anymore",
      AR: "ONE O TWO Conversation is not active anymore",
      FR: "ONE O TWO Conversation is not active anymore",
      TR: "ONE O TWO Conversation is not active anymore"
    },
    DOUBLE_CLICK_FOR_GOOGLE_LENS: {
      ENG: "Double click for Google lens",
      AR: "Double click for Google lens",
      FR: "Double click for Google lens",
      TR: "Double click for Google lens"
    },
    NO_WEB_USER_PAYMENT_ARCHIVE_DATA: {
      AR: "No Data In User Payment Server Archive",
      ENG: "No Data In User Payment Server Archive",
      TR: "No Data In User Payment Server Archive",
      FR: "No Data In User Payment Server Archive"
    },
    WRONG_REFFERAL_CODE: {
      AR: " Wrong referral code",
      FR: " Wrong referral code",
      ENG: " Wrong referral code",
      TR: " Wrong referral code"
    },
    ADMIN_USERS_HAVE_ALREADY_ANOTHER_ACTIVE_POOL: {
      AR: "You currently have an active pool!",
      TR: "You currently have an active pool!",
      FR: "You currently have an active pool!",
      ENG: "You currently have an active pool!"
    },
    TYPE_OF_MARRIAGE: {
      AR: "Marriage Type",
      ENG: "Marriage Type",
      TR: "Marriage Type",
      FR: "Marriage Type"
    },
    MARITAL_STATUS: {
      AR: "Marital status",
      ENG: "Marital status",
      TR: "Marital status",
      FR: "Marital status"
    },
    EDUCATION_LEVEL: {
      AR: "Education",
      ENG: "Education",
      TR: "Education",
      FR: "Education"
    },
    WORK_LEVEL: {
      AR: "Work",
      ENG: "Work",
      TR: "Work",
      FR: "Work"
    },
    SMOKING_LEVEL: {
      AR: "Smoking",
      ENG: "Smoking",
      TR: "Smoking",
      FR: "Smoking"
    },
    SKIN_COLOR: {
      AR: "Skin Color",
      ENG: "Skin Color",
      TR: "Skin Color",
      FR: "Skin Color"
    },
    VEIL: {
      AR: "Veil",
      ENG: "Veil",
      TR: "Veil",
      FR: "Veil"
    },
    INCOME: {
      AR: "Income",
      ENG: "Income",
      TR: "Income",
      FR: "Income"
    },
    RELIGION: {
      AR: "Religion",
      ENG: "Religion",
      TR: "Religion",
      FR: "Religion"
    },
    HAVING_KIDS: {
      AR: "Having kids",
      ENG: "Having kids",
      TR: "Having kids",
      FR: "Having kids"
    },
    FEMALE_WORK_STUDY: {
      AR: "Female work or study",
      ENG: "Female work or study",
      TR: "Female work or study",
      FR: "Female work or study"
    },
    BELONGS_TO_TRIBE: {
      AR: "Belongs to a tribe",
      ENG: "Belongs to a tribe",
      TR: "Belongs to a tribe",
      FR: "Belongs to a tribe"
    },
    RELOCATION: {
      AR: "Relocation",
      ENG: "Relocation",
      TR: "Relocation",
      FR: "Relocation"
    },
    REGULAR: {
      AR: "Regular",
      ENG: "Regular",
      TR: "Regular",
      FR: "Regular"
    },
    POLY: {
      AR: "Poly",
      ENG: "Poly",
      TR: "Poly",
      FR: "Poly"
    },
    MISYAR: {
      AR: "Misyar",
      ENG: "Misyar",
      TR: "Misyar",
      FR: "Misyar"
    },
    LEAD: {
      AR: "Lead",
      ENG: "Lead",
      TR: "Lead",
      FR: "Lead"
    },
    IGNORE: {
      AR: "Ignore",
      ENG: "Ignore",
      TR: "Ignore",
      FR: "Ignore"
    },
    MOVE_TO: {
      AR: "Move To",
      ENG: "Move To",
      TR: "Move To",
      FR: "Move To"
    },
    SELECT_ALL: {
      AR: "Select All",
      ENG: "Select All",
      TR: "Select All",
      FR: "Select All"
    },
    WEB_REFUND_ATTENTION: {
      AR: "Attention: This user has previously received a refund.",
      ENG: "Attention: This user has previously received a refund.",
      TR: "Attention: This user has previously received a refund.",
      FR: "Attention: This user has previously received a refund."
    },
    ARE_YOU_SURE_YOU_WANT_TO_CONTINUE: {
      AR: "Are you sure you want to continue?",
      TR: "Are you sure you want to continue?",
      ENG: "Are you sure you want to continue?",
      FR: "Are you sure you want to continue?"
    },
    COUNT_SELECTED: {
      AR: "Count Selected",
      ENG: "Count Selected",
      TR: "Count Selected",
      FR: "Count Selected"
    },
    COUNT: {
      AR: "Count",
      ENG: "Count",
      TR: "Count",
      FR: "Count"
    },
    FILTERS: {
      AR: "Filters",
      ENG: "Filters",
      TR: "Filters",
      FR: "Filters"
    },
    MIN_AGE: {
      AR: "Min Age",
      ENG: "Min Age",
      TR: "Min Age",
      FR: "Min Age"
    },
    MAX_AGE: {
      AR: "Max Age",
      ENG: "Max Age",
      TR: "Max Age",
      FR: "Max Age"
    },
    UNDEFINED: {
      AR: "Undefined",
      ENG: "Undefined",
      TR: "Undefined",
      FR: "Undefined"
    },
    APPLY: {
      AR: "Apply",
      ENG: "Apply",
      TR: "Apply",
      FR: "Apply"
    },
    MAX_AGE_HAS_TO_BE_BIGGER_MIN_AGE: {
      AR: "Max age should be bigger than Min age! There Values will be switched",
      ENG: "Max age should be bigger than Min age! There Values will be switched",
      TR: "Max age should be bigger than Min age! There Values will be switched",
      FR: "Max age should be bigger than Min age! There Values will be switched"
    },
    FILTERS_RESET: {
      AR: "Reset Filters",
      ENG: "Reset Filters",
      TR: "Reset Filters",
      FR: "Reset Filters"
    },
    BULK_MESSAGES_BOX: {
      AR: "Bulk Messages Box",
      ENG: "Bulk Messages Box",
      TR: "Bulk Messages Box",
      FR: "Bulk Messages Box"
    },
    PLEASE_AT_LEAST_ONE_USER: {
      AR: "Please select at least one user",
      ENG: "Please select at least one user",
      TR: "Please select at least one user",
      FR: "Please select at least one user"
    },
    SENDING: {
      AR: "Sending...",
      ENG: "Sending...",
      TR: "Sending...",
      FR: "Sending..."
    },
    MARK_AS_READ: {
      AR: "Mark as read",
      ENG: "Mark as read",
      TR: "Mark as read",
      FR: "Mark as read"
    },
    UNREAD_MESSAGES: {
      AR: "Unread Messages",
      ENG: "Unread Messages",
      TR: "Unread Messages",
      FR: "Unread Messages"
    },
    NO_PAID_USERS_FOUND: {
      AR: "No Paid users has been found!",
      ENG: "No Paid users has been found!",
      TR: "No Paid users has been found!",
      FR: "No Paid users has been found!"
    },
    PAID_USERS: {
      AR: "Paid Users",
      ENG: "Paid Users",
      TR: "Paid Users",
      FR: "Paid Users"
    },
    RESULTS_NUMBER: {
      AR: "Results number",
      ENG: "Results number",
      TR: "Results number",
      FR: "Results number"
    },
    CLEAR_RESULTS: {
      AR: "Clear Results",
      ENG: "Clear Results",
      TR: "Clear Results",
      FR: "Clear Results"
    },
    NO_MATCHES_FOUND: {
      AR: "NO Matches has been found",
      ENG: "NO Matches has been found",
      TR: "NO Matches has been found",
      FR: "NO Matches has been found"
    },
    CREATE_ONE_O_ONE_M: {
      AR: "Create 101M",
      ENG: "Create 101M",
      TR: "Create 101M",
      FR: "Create 101M"
    },
    SEND_ONE_O_ONE_M_MESSAGE_PLACE_HOLDER: {
      AR: "Write the custom message to send in the 101M",
      ENG: "Write the custom message to send in the 101M",
      TR: "Write the custom message to send in the 101M",
      FR: "Write the custom message to send in the 101M"
    },
    CITY_OF_RESIDENCE: {
      ENG: "City of residence",
      AR: "City of residence",
      FR: "City of residence",
      TR: "City of residence"
    },
    GET_CITIES: {
      ENG: "Get Cities",
      AR: "Get Cities",
      FR: "Get Cities",
      TR: "Get Cities"
    },
    NO_CITIES_FOUND: {
      ENG: "NO Cities has been found",
      AR: "NO Cities has been found",
      FR: "NO Cities has been found",
      TR: "NO Cities has been found"
    },
    GET_CONVESATIONS: {
      ENG: "Get Conversations",
      AR: "Get Conversations",
      FR: "Get Conversations",
      TR: "Get Conversations"
    },
    NO_APPROVED_MATCHES_FOUND: {
      AR: "NO Approved Matches has been found",
      ENG: "NO Approved Matches has been found",
      TR: "NO Approved Matches has been found",
      FR: "NO Approved Matches has been found"
    },
    CONTACTED: {
      ENG: "Contacted",
      AR: "Contacted",
      FR: "Contacted",
      TR: "Contacted"
    },
    MATCH_APP_LANGUAGE: {
      ENG: "Match Application Language",
      AR: "Match Application Language",
      FR: "Match Application Language",
      TR: "Match Application Language"
    },

    SUPERVISOR_RECEIPT_COMPENSATION: {
      AR: "Supervisor Receipt Compensation",
      ENG: "Supervisor Receipt Compensation",
      TR: "Supervisor Receipt Compensation",
      FR: "Supervisor Receipt Compensation"
    },
    SUPERVISOR_RECEIPT_COMPENSATION_ISSUES_ADDED_SUCCESSFULLY: {
      AR: "Supervisor Issues Added successfully",
      ENG: "Supervisor Issues Added successfully",
      FR: "Supervisor Issues Added successfully",
      TR: "Supervisor Issues Added successfully"
    },
    RECEIPT_FOUND_FOR_THIS_MONTH: {
      AR: "Receipt Found For This Month",
      ENG: "Receipt Found For This Month",
      FR: "Receipt Found For This Month",
      TR: "Receipt Found For This Month"
    },
    SUBMIT_DATE_IS_SPECIFIC: {
      AR: "Submit Button Has Specific Date Between 26 and 28",
      ENG: "Submit Button Has Specific Date Between 26 and 28",
      FR: "Submit Button Has Specific Date Between 26 and 28",
      TR: "Submit Button Has Specific Date Between 26 and 28"
    },
    DESCRIPTION_THRESHOLD: {
      AR: "Description Threshold",
      FR: "Description Threshold",
      ENG: "Description Threshold",
      TR: "Description Threshold"
    },
    DESCRIPTION_DISCOUNT: {
      AR: "Description Discount",
      FR: "Description Discount",
      ENG: "Description Discount",
      TR: "Description Discount"
    },
    DESCRIPTION_PRICING: {
      AR: "Description Pricing",
      FR: "Description Pricing",
      ENG: "Description Pricing",
      TR: "Description Pricing"
    },
    REPORT_THRESHOLD: {
      AR: "Report Threshold",
      FR: "Report Threshold",
      ENG: "Report Threshold",
      TR: "Report Threshold"
    },
    REPORT_DISCOUNT: {
      AR: "Report Discount",
      FR: "Report Discount",
      ENG: "Report Discount",
      TR: "Report Discount"
    },
    REPORT_PRICING: {
      AR: "Report Pricing",
      FR: "Report Pricing",
      ENG: "Report Pricing",
      TR: "Report Pricing"
    },
    INVESTIGATION_CASES_THRESHOLD: {
      AR: "Investigation Cases Threshold",
      FR: "Investigation Cases Threshold",
      ENG: "Investigation Cases Threshold",
      TR: "Investigation Cases Threshold"
    },
    INVESTIGATION_CASES_DISCOUNT: {
      AR: "Investigation Cases Discount",
      FR: "Investigation Cases Discount",
      ENG: "Investigation Cases Discount",
      TR: "Investigation Cases Discount"
    },
    INVESTIGATION_CASES_PRICING: {
      AR: "Investigation Cases Pricing",
      FR: "Investigation Cases Pricing",
      ENG: "Investigation Cases Pricing",
      TR: "Investigation Cases Pricing"
    },
    PICTURE_THRESHOLD: {
      AR: "Picture Threshold",
      FR: "Picture Threshold",
      ENG: "Picture Threshold",
      TR: "Picture Threshold"
    },
    PICTURE_PRICING: {
      AR: "Picture Pricing",
      FR: "Picture Pricing",
      ENG: "Picture Pricing",
      TR: "Picture Pricing"
    },
    PICTURE_DISCOUNT: {
      AR: "Picture Discount",
      FR: "Picture Discount",
      ENG: "Picture Discount",
      TR: "Picture Discount"
    },
    PREVIOUS_RECEIPT_MONTH: {
      AR: "Previous Receipts Months",
      ENG: "Previous Receipts Months",
      FR: " Previous Receipts Months",
      TR: "Previous Receipts Months"
    },
    CURRENT_RECEIPT_MONTH: {
      AR: "Current Receipt Month",
      ENG: "Current Receipt Month",
      FR: " Current Receipt Month",
      TR: "Current Receipt Month"
    },
    IMAGE_STATUS_DELETED: {
      AR: "Image is deleted by user on App, please press 'Get'",
      ENG: "Image is deleted by user on App, please press 'Get'",
      FR: "Image is deleted by user on App, please press 'Get'",
      TR: "Image is deleted by user on App, please press 'Get'"
    },
    SLOT: {
      AR: "Slot %EXTRA_DATA%",
      ENG: "Slot %EXTRA_DATA%",
      TR: "Slot %EXTRA_DATA%",
      FR: "Slot %EXTRA_DATA%"
    },
    ALL_DAYS: {
      AR: "All Days",
      ENG: "All Days",
      TR: "All Days",
      FR: "All Days"
    },
    MONDAY: {
      AR: "Monday",
      ENG: "Monday",
      TR: "Monday",
      FR: "Monday"
    },
    TUESDAY: {
      AR: "Tuesday",
      ENG: "Tuesday",
      TR: "Tuesday",
      FR: "Tuesday"
    },
    WEDNESDAY: {
      AR: "Wednesday",
      ENG: "Wednesday",
      TR: "Wednesday",
      FR: "Wednesday"
    },
    THURSDAY: {
      AR: "Thursday",
      ENG: "Thursday",
      TR: "Thursday",
      FR: "Thursday"
    },
    FRIDAY: {
      AR: "Friday",
      ENG: "Friday",
      TR: "Friday",
      FR: "Friday"
    },
    SATURDAY: {
      AR: "Saturday",
      ENG: "Saturday",
      TR: "Saturday",
      FR: "Saturday"
    },
    SUNDAY: {
      AR: "Sunday",
      ENG: "Sunday",
      TR: "Sunday",
      FR: "Sunday"
    },
    CHOOSE_PROPER_TIME_RANGE: {
      AR: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells",
      ENG: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells",
      TR: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells",
      FR: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells"
    },
    NO_LONGER_ACTIVE_POOL: {
      AR: "No longer active pool, Please refresh the page!",
      ENG: "No longer active pool, Please refresh the page!",
      TR: "No longer active pool, Please refresh the page!",
      FR: "No longer active pool, Please refresh the page!"
    },
    DISABLE: {
      AR: "Disabled",
      ENG: "Disable",
      TR: "Disable",
      FR: "Disable"
    },
    ENABLE: {
      AR: "Enable",
      ENG: "Enable",
      TR: "Enable",
      FR: "Enable"
    },
    ENABLE_SELECTED_1O1M: {
      AR: "Enable Selected 101M",
      ENG: "Enable Selected 101M",
      TR: "Enable Selected 101M",
      FR: "Enable Selected 101M"
    },
    DISABLE_SELECTED_1O1M: {
      AR: "Disable Selected 101M",
      ENG: "Disable Selected 101M",
      TR: "Disable Selected 101M",
      FR: "Disable Selected 101M"
    },
    PROFILE_ID: {
      AR: "Profile ID",
      ENG: "Profile ID",
      FR: "Profile ID",
      TR: "Profile ID"
    },
    WRONG_PROFILE_ID: {
      AR: "Wrong Profile ID",
      ENG: "Wrong Profile ID",
      TR: "Wrong Profile ID",
      FR: "Wrong Profile ID"
    },
    PROFILE_ID_NOT_FOUND: {
      AR: "Profile ID Not Found",
      ENG: "Profile ID Not Found",
      TR: "Profile ID Not Found",
      FR: "Profile ID Not Found"
    },
    RESET_PASSWORD_CONFIRMATION_POPUP: {
      ENG: "Are you sure you want to reset the password for %EXTRA_DATA%?",
      AR: "Are you sure you want to reset the password for %EXTRA_DATA%?",
      TR: "Are you sure you want to reset the password for %EXTRA_DATA%?",
      FR: "Are you sure you want to reset the password for %EXTRA_DATA%?"
    },
    CLEAN_POOL_CONFIRMATION_POPUP: {
      ENG: "You already have an active pool. Do you want to clean your pool and take this one instead?",
      AR: "You already have an active pool. Do you want to clean your pool and take this one instead?",
      TR: "You already have an active pool. Do you want to clean your pool and take this one instead?",
      FR: "You already have an active pool. Do you want to clean your pool and take this one instead?"
    },
    USER_DATA: {
      ENG: "User Data",
      AR: "User Data",
      TR: "User Data",
      FR: "User Data"
    },
    USER_PROFILE: {
      ENG: "User Profile",
      AR: "User Profile",
      TR: "User Profile",
      FR: "User Profile"
    },
    THERE_IS_ANOTHER_AVAILABLE_KHATTABA: {
      AR: "Feature is already being used. Try again later",
      ENG: "Feature is already being used. Try again later",
      TR: "Feature is already being used. Try again later",
      FR: "Feature is already being used. Try again later"
    },
    KHATTABAT_REMUNERATION: {
      AR: "Khattabat Remuneration",
      ENG: "Khattabat Remuneration",
      TR: "Khattabat Remuneration",
      FR: "Khattabat Remuneration"
    },
    PER_CYCLE: {
      AR: "Per Cycle",
      ENG: "Per Cycle",
      TR: "Per Cycle",
      FR: "Per Cycle"
    },
    KHATTABAT_ADMIN: {
      AR: "Khattabat Admin",
      ENG: "Khattabat Admin",
      TR: "Khattabat Admin",
      FR: "Khattabat Admin"
    },
    NO_KHATTABAT_ADMIN: {
      AR: "There is no Khattabat Admin",
      ENG: "There is no Khattabat Admin",
      TR: "There is no Khattabat Admin",
      FR: "There is no Khattabat Admin"
    },
    ADMIN_KHATTABAT_REMUNERATIONS: {
      AR: "Khattabat admin remunerations per cycle",
      ENG: "Khattabat admin remunerations per cycle",
      TR: "Khattabat admin remunerations per cycle",
      FR: "Khattabat admin remunerations per cycle"
    },
    VIP: {
      AR: "VIP",
      ENG: "VIP",
      TR: "VIP",
      FR: "VIP"
    },
    PLUS: {
      AR: "PLUS",
      ENG: "PLUS",
      TR: "PLUS",
      FR: "PLUS"
    },
    KHATTABAT_TAG: {
      AR: "KHATTABAT",
      ENG: "KHATTABAT",
      TR: "KHATTABAT",
      FR: "KHATTABAT"
    },
    BOOST: {
      AR: "BOOST",
      ENG: "BOOST",
      TR: "BOOST",
      FR: "BOOST"
    },
    REWIND: {
      AR: "REWIND",
      ENG: "REWIND",
      TR: "REWIND",
      FR: "REWIND"
    },
    READ: {
      AR: "READ",
      ENG: "READ",
      TR: "READ",
      FR: "READ"
    },
    PLUS_DAYS: {
      AR: "PLUS Days",
      ENG: "PLUS Days",
      FR: "PLUS Days",
      TR: "PLUS Days"
    },
    PLUS_HOURS: {
      AR: "PLUS Hours",
      ENG: "PLUS Hours",
      FR: "PLUS Hours",
      TR: "PLUS Hours"
    },
    PLUS_MIN: {
      AR: "PLUS Min",
      ENG: "PLUS Min",
      FR: "PLUS Min",
      TR: "PLUS Min"
    },
    KHATTABAT_DAYS: {
      AR: "Khattabat Days",
      ENG: "Khattabat Days",
      FR: "Khattabat Days",
      TR: "Khattabat Days"
    },
    KHATTABAT_HOURS: {
      AR: "Khattabat Hours",
      ENG: "Khattabat Hours",
      FR: "Khattabat Hours",
      TR: "Khattabat Hours"
    },
    KHATTABAT_MIN: {
      AR: "Khattabat Min",
      ENG: "Khattabat Min",
      FR: "Khattabat Min",
      TR: "Khattabat Min"
    },
    MAKE_PLUS: {
      AR: "Make PLUS",
      ENG: "Make PLUS",
      FR: "Make PLUS",
      TR: "Make PLUS"
    },
    MAKE_KHATTABAT: {
      AR: "Make Khattabat",
      ENG: "Make Khattabat",
      FR: "Make Khattabat",
      TR: "Make Khattabat"
    },
    ONE_O_TWO_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to reactivate this 1O2 conversation? ",
      TR: "Are you sure you want to reactivate this 1O2 conversation? ",
      FR: "Are you sure you want to reactivate this 1O2 conversation? ",
      ENG: "Are you sure you want to reactivate this 1O2 conversation? "
    },
    KHATTABAT_ONE_O_TWO_HISTORIES_POPUP_TITLE: {
      AR: "Histories",
      TR: "Histories",
      FR: "Histories",
      ENG: "Histories"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_EVENT_ADDED: {
      AR: "Added",
      TR: "Added",
      FR: "Added",
      ENG: "Added"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_EVENT_UPDATED: {
      AR: "Updated",
      TR: "Updated",
      FR: "Updated",
      ENG: "Updated"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_EVENT_REMOVED: {
      AR: "Removed",
      TR: "Removed",
      FR: "Removed",
      ENG: "Removed"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_EVENT_HIDDEN: {
      AR: "Hidden",
      TR: "Hidden",
      FR: "Hidden",
      ENG: "Hidden"
    },
    KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE_FOR_ME: {
      AR: "Hidden for me",
      TR: "Hidden for me",
      FR: "Hidden for me",
      ENG: "Hidden for me"
    },
    KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE_FOR_EVERYONE: {
      AR: "Hidden for everyone",
      TR: "Hidden for everyone",
      FR: "Hidden for everyone",
      ENG: "Hidden for everyone"
    },
    KHATTABAT_ONE_O_TWO_MESSAGE_HISTORY_BUTTON: {
      AR: "History",
      TR: "History",
      FR: "History",
      ENG: "History"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_SENDER: {
      AR: "Sender",
      TR: "Sender",
      FR: "Sender",
      ENG: "Sender"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_RECIPIENT: {
      AR: "Recipient",
      TR: "Recipient",
      FR: "Recipient",
      ENG: "Recipient"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_SENDER_KHATTABA: {
      AR: "Sender: Khattaba",
      TR: "Sender: Khattaba",
      FR: "Sender: Khattaba",
      ENG: "Sender: Khattaba"
    },
    KHATTABAT_ONE_O_TWO_HISTORY_EVENT_CURRENT: {
      AR: "Current",
      TR: "Current",
      FR: "Current",
      ENG: "Current"
    },
    USER_IS_NOT_MALE_USER: {
      AR: "User is not a Male user",
      TR: "User is not a Male user",
      FR: "User is not a Male user",
      ENG: "User is not a Male user"
    },
    USER_NEVER_PAYING_KHATTABAT: {
      AR: "User was never a paying Khattabat Client",
      ENG: "User was never a paying Khattabat Client",
      FR: "User was never a paying Khattabat Client",
      TR: "User was never a paying Khattabat Client"
    },
    INCORRECT_PLUS_DAYS_HOURS: {
      ENG: "Cannot give less than one day plus and less than one hour to a user",
      AR: "Cannot give less than one day plus and less than one hour to a user",
      FR: "Cannot give less than one day plus and less than one hour to a user",
      TR: "Cannot give less than one day plus and less than one hour to a user"
    },
    USER_PLUS_ADDED_SUCCESSFULLY: {
      ENG: "User PLUS added successfully",
      AR: "User PLUS added successfully",
      FR: "User PLUS added successfully",
      TR: "User PLUS added successfully"
    },
    INCORRECT_KHATTABAT_DAYS_HOURS: {
      ENG: "Cannot give less than one day khattabat and less than one hour to a user",
      AR: "Cannot give less than one day khattabat and less than one hour to a user",
      FR: "Cannot give less than one day khattabat and less than one hour to a user",
      TR: "Cannot give less than one day khattabat and less than one hour to a user"
    },
    USER_KHATTABAT_ADDED_SUCCESSFULLY: {
      ENG: "User KHATTABAT added successfully",
      AR: "User KHATTABAT added successfully",
      FR: "User KHATTABAT added successfully",
      TR: "User KHATTABAT added successfully"
    },
    USER_IS_NOT_MATCHED_TO_THIS_KHATTABA: {
      ENG: "User Is Not Matched To This old Khattaba",
      AR: "User Is Not Matched To This old Khattaba",
      FR: "User Is Not Matched To This old Khattaba",
      TR: "User Is Not Matched To This old Khattaba"
    },
    REASSIGNMENT_IS_COMPLETED: {
      ENG: "Reassignment is completed!",
      AR: "Reassignment is completed!",
      FR: "Reassignment is completed!",
      TR: "Reassignment is completed!"
    },
    BAN_UNTIL: {
      ENG: "Ban Until:",
      AR: "Ban Until:",
      FR: "Ban Until:",
      TR: "Ban Until:"
    },
    NUMBER_OF_DAYS: {
      ENG: "Number of Days:",
      AR: "Number of Days:",
      FR: "Number of Days:",
      TR: "Number of Days:"
    },
    INVESTIGATION_ID: {
      ENG: "Investigation ID:",
      AR: "Investigation ID:",
      FR: "Investigation ID:",
      TR: "Investigation ID:"
    },
    REPORT_ID: {
      ENG: "Report ID:",
      AR: "Report ID:",
      FR: "Report ID:",
      TR: "Report ID:"
    },
    SUBSCRIPTION: {
      ENG: "Subscription",
      AR: "Subscription",
      FR: "Subscription",
      TR: "Subscription"
    },
    AUDITORS_EFFICIENCY: {
      AR: "Auditors Efficiency",
      ENG: "Auditors Efficiency",
      FR: "Auditors Efficiency",
      TR: "Auditors Efficiency"
    },
    TURN_KHATTABAT_ON_OFF: {
      ENG: "Turn Khattabat on/off",
      AR: "Turn Khattabat on/off",
      FR: "Turn Khattabat on/off",
      TR: "Turn Khattabat on/off"
    },
    UPDATE: {
      ENG: "Update",
      AR: "Update",
      FR: "Update",
      TR: "Update"
    },
    RC_CAPACITY: {
      ENG: "RC Capacity",
      AR: "RC Capacity",
      FR: "RC Capacity",
      TR: "RC Capacity"
    },
    REACTIVATE: {
      ENG: "Reactivate",
      AR: "Reactivate",
      FR: "Reactivate",
      TR: "Reactivate"
    },
    ACCOUNT_CREATED_ON: {
      AR: "Account Created on",
      ENG: "Account Created on",
      FR: "Account Created on",
      TR: "Account Created on"
    },
    DELETED_BY_MATCH: {
      AR: "Deleted By Match",
      ENG: "Deleted By Match",
      FR: "Deleted By Match",
      TR: "Deleted By Match"
    },
    AMOUNT: {
      AR: "Amount",
      ENG: "Amount",
      FR: "Amount",
      TR: "Amount"
    },
    FREE_PAID_IN_HOURS_DAYS: {
      AR: "(Free in hours, Paid in Days)",
      ENG: "(Free in hours, Paid in Days)",
      FR: "(Free in hours, Paid in Days)",
      TR: "(Free in hours, Paid in Days)"
    },
    MESSAGE_ERA: {
      AR: "Message Era",
      ENG: "Message Era",
      FR: "Message Era",
      TR: "Message Era"
    },
    KHATTABAT_DATA: {
      AR: "Khattabat Data",
      ENG: "Khattabat Data",
      FR: "Khattabat Data",
      TR: "Khattabat Data"
    },
    GET_LATEST: {
      AR: "Get Latest",
      ENG: "Get Latest",
      FR: "Get Latest",
      TR: "Get Latest"
    },
    DATA_COLLECTION: {
      AR: "Data Collection",
      ENG: "Data Collection",
      FR: "Data Collection",
      TR: "Data Collection"
    },
    NEW_CLIENTS: {
      AR: "New Clients",
      ENG: "New Clients",
      FR: "New Clients",
      TR: "New Clients"
    },
    CAPACITY: {
      AR: "Capacity",
      ENG: "Capacity",
      FR: "Capacity",
      TR: "Capacity"
    },
    ASSIGN_CLIENT_TO_ME: {
      AR: "Assign Client To Me",
      ENG: "Assign Client To Me",
      FR: "Assign Client To Me",
      TR: "Assign Client To Me"
    },
    LIMIT_REACHED_KHATTABA_CLIENTS: {
      AR: "You have reached the limit of number of clients, contact your supervisor",
      ENG: "You have reached the limit of number of clients, contact your supervisor",
      FR: "You have reached the limit of number of clients, contact your supervisor",
      TR: "You have reached the limit of number of clients, contact your supervisor"
    },
    NO_NEW_CLIENTS_AVAILABLE: {
      AR: "There are no new clients right now",
      ENG: "There are no new clients right now",
      FR: "There are no new clients right now",
      TR: "There are no new clients right now"
    },
    CLIENT_ALREADY_ASSIGNED_TO_ANOTHER_KHATTABA: {
      AR: "This client was just assigned to another khattaba, please try again",
      ENG: "This client was just assigned to another khattaba, please try again",
      FR: "This client was just assigned to another khattaba, please try again",
      TR: "This client was just assigned to another khattaba, please try again"
    },
    ASSIGN_NEW_CLIENT_CONFIRMATION_POP_UP: {
      AR: "Are you sure you want to assign a new client to your account?",
      ENG: "Are you sure you want to assign a new client to your account?",
      FR: "Are you sure you want to assign a new client to your account?",
      TR: "Are you sure you want to assign a new client to your account?"
    },
    DOWNLOAD_CSV: {
      AR: "Download CSV",
      ENG: "Download CSV",
      FR: "Download CSV",
      TR: "Download CSV"
    },
    INVOICE_NUMBER: {
      AR: "Invoice Number",
      ENG: "Invoice Number",
      FR: "Invoice Number",
      TR: "Invoice Number"
    },
    SEARCH_BY_INVOICE_NUMBER: {
      AR: "By invoice number",
      ENG: "By invoice number",
      FR: "By invoice number",
      TR: "By invoice number"
    },
    KHATTABA_102_COUNTER: {
      AR: "K:%EXTRA_DATA%",
      ENG: "K:%EXTRA_DATA%",
      FR: "K:%EXTRA_DATA%",
      TR: "K:%EXTRA_DATA%"
    },
    CLIENT_102_COUNTER: {
      AR: "C:%EXTRA_DATA%",
      ENG: "C:%EXTRA_DATA%",
      FR: "C:%EXTRA_DATA%",
      TR: "C:%EXTRA_DATA%"
    },
    MATCH_102_COUNTER: {
      AR: "M:%EXTRA_DATA%",
      ENG: "M:%EXTRA_DATA%",
      FR: "M:%EXTRA_DATA%",
      TR: "M:%EXTRA_DATA%"
    },
    QUALITY: {
      AR: "Quality",
      ENG: "Quality",
      FR: "Quality",
      TR: "Quality"
    },
    NOTICE_EMAIL: {
      AR: "Notice Email",
      ENG: "Notice Email",
      FR: "Notice Email",
      TR: "Notice Email"
    },
    REACTIVATE_KHATTABA_CLIENT_CONFIRMATION_POP_UP: {
      AR: "Are you sure you want to send a notice email to this client?",
      ENG: "Are you sure you want to send a notice email to this client?",
      FR: "Are you sure you want to send a notice email to this client?",
      TR: "Are you sure you want to send a notice email to this client?"
    },
    CANNOT_REACTIVATE_KHATTABA_CLIENT_POPUP: {
      AR: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive",
      ENG: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive",
      FR: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive",
      TR: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive"
    },
    SILVER_SUBSCRIPTION_HISTORY_FOR: {
      AR: "SILVER Subscription History For",
      ENG: "SILVER Subscription History For",
      FR: "SILVER Subscription History For",
      TR: "SILVER Subscription History For"
    },
    GOLD_SUBSCRIPTION_HISTORY_FOR: {
      AR: "GOLD Subscription History For",
      ENG: "GOLD Subscription History For",
      FR: "GOLD Subscription History For",
      TR: "GOLD Subscription History For"
    },
    PLATINUM_SUBSCRIPTION_HISTORY_FOR: {
      AR: "PLATINUM Subscription History For",
      ENG: "PLATINUM Subscription History For",
      FR: "PLATINUM Subscription History For",
      TR: "PLATINUM Subscription History For"
    },
    POWER_BUNDLE_SUBSCRIPTION_HISTORY_FOR: {
      AR: "POWER BUNDLE Subscription History For",
      ENG: "POWER BUNDLE Subscription History For",
      FR: "POWER BUNDLE Subscription History For",
      TR: "POWER BUNDLE Subscription History For"
    },
    READ_SUBSCRIPTION_HISTORY_FOR: {
      AR: "READ Subscription History For",
      ENG: "READ Subscription History For",
      FR: "READ Subscription History For",
      TR: "READ Subscription History For"
    },
    VIP_SUBSCRIPTION_HISTORY_FOR: {
      AR: "VIP Subscription History For",
      ENG: "VIP Subscription History For",
      FR: "VIP Subscription History For",
      TR: "VIP Subscription History For"
    },
    PLUS_SUBSCRIPTION_HISTORY_FOR: {
      AR: "PLUS Subscription History For",
      ENG: "PLUS Subscription History For",
      FR: "PLUS Subscription History For",
      TR: "PLUS Subscription History For"
    },
    KHATTABAT_SUBSCRIPTION_HISTORY_FOR: {
      AR: "KHATTABAT Subscription History For",
      ENG: "KHATTABAT Subscription History For",
      FR: "KHATTABAT Subscription History For",
      TR: "KHATTABAT Subscription History For"
    },
    BOOST_SUBSCRIPTION_HISTORY_FOR: {
      AR: "BOOST Subscription History For",
      ENG: "BOOST Subscription History For",
      FR: "BOOST Subscription History For",
      TR: "BOOST Subscription History For"
    },
    COUNT_HINT_SUBTEXT: {
      AR: "(Count)",
      ENG: "(Count)",
      FR: "(Count)",
      TR: "(Count)"
    },
    REWIND_SUBSCRIPTION_HISTORY_FOR: {
      AR: "REWIND Subscription History For",
      ENG: "REWIND Subscription History For",
      FR: "REWIND Subscription History For",
      TR: "REWIND Subscription History For"
    },
    SELFIE_VERIFICATION_PHOTOS: {
      AR: "Selfie Verification Photos",
      ENG: "Selfie Verification Photos",
      FR: "Selfie Verification Photos",
      TR: "Selfie Verification Photos"
    },
    KHATTABA_V3_IS_ALREADY_TURNED_OFF: {
      AR: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required",
      ENG: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required",
      FR: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required",
      TR: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required"
    },
    BP_USERS: {
      AR: "BP Users",
      ENG: "BP Users",
      TR: "BP Users",
      FR: "BP Users"
    },
    SUB_TAB_ACCESS_SUMMARY: {
      AR: "Sub Tab Access Summary",
      ENG: "Sub Tab Access Summary",
      TR: "Sub Tab Access Summary",
      FR: "Sub Tab Access Summary"
    },
    GENERATED_TABLES_SUMMARY: {
      AR: "Generated Tables Summary",
      ENG: "Generated Tables Summary",
      TR: "Generated Tables Summary",
      FR: "Generated Tables Summary"
    },
    USER_UNDER_CSR_INVESTIGATION_BUT_WILL_APPEAR_SOON: {
      AR: "User is currently under investigation and will appear when the time is right",
      ENG: "User is currently under investigation and will appear when the time is right",
      TR: "User is currently under investigation and will appear when the time is right",
      FR: "User is currently under investigation and will appear when the time is right"
    },
    MIN_HEIGHT: {
      AR: "Min Height",
      ENG: "Min Height",
      TR: "Min Height",
      FR: "Min Height"
    },
    MAX_HEIGHT: {
      AR: "Max Height",
      ENG: "Max Height",
      TR: "Max Height",
      FR: "Max Height"
    },
    MIN_WEIGHT: {
      AR: "Min Weight",
      ENG: "Min Weight",
      TR: "Min Weight",
      FR: "Min Weight"
    },
    MAX_WEIGHT: {
      AR: "Max Weight",
      ENG: "Max Weight",
      TR: "Max Weight",
      FR: "Max Weight"
    },
    MIN_AGE_LESS_THAN_MAX_AGE: {
      AR: "Minimum age should be less than maximum age",
      ENG: "Minimum age should be less than maximum age",
      TR: "Minimum age should be less than maximum age",
      FR: "Minimum age should be less than maximum age"
    },

    MIN_WEIGHT_LESS_THAN_MAX_WEIGHT: {
      AR: "Minimum weight should be less than maximum weight",
      ENG: "Minimum weight should be less than maximum weight",
      TR: "Minimum weight should be less than maximum weight",
      FR: "Minimum weight should be less than maximum weight"
    },

    MIN_HEIGHT_LESS_THAN_MAX_HEIGHT: {
      AR: "Minimum height should be less than maximum height",
      ENG: "Minimum height should be less than maximum height",
      TR: "Minimum height should be less than maximum height",
      FR: "Minimum height should be less than maximum height"
    },

    FEATURE_ROLLOUT_PERCENTAGE: {
      ENG: "Feature RO %",
      AR: "Feature RO %",
      FR: "Feature RO %",
      TR: "Feature RO %"
    },
    EXCLUDE: {
      AR: "Exclude",
      FR: "Exclude",
      TR: "Exclude",
      ENG: "Exclude"
    },
    ALL_CLIENTS: {
      AR: "All Clients",
      FR: "All Clients",
      TR: "All Clients",
      ENG: "All Clients"
    },
    REQUIRES_ATTENTION: {
      AR: "Requires Attention",
      FR: "Requires Attention",
      TR: "Requires Attention",
      ENG: "Requires Attention"
    },
    OTHER_AUDITORS_PERFORMANCE: {
      AR: "Other Auditors Performance",
      FR: "Other Auditors Performance",
      TR: "Other Auditors Performance",
      ENG: "Other Auditors Performance"
    },
    BAN_SCAMMER: {
      AR: "Ban - Scammer",
      FR: "Ban - Scammer",
      TR: "Ban - Scammer",
      ENG: "Ban - Scammer"
    },
    WARN_SOCIAL_MEDIA_ACCOUNT: {
      AR: "Warn - Social Media Account",
      FR: "Warn - Social Media Account",
      TR: "Warn - Social Media Account",
      ENG: "Warn - Social Media Account"
    },
    WARN_BAD_LANGUAGE: {
      AR: "Warn - Bad Language",
      FR: "Warn - Bad Language",
      TR: "Warn - Bad Language",
      ENG: "Warn - Bad Language"
    },
    REPORT_ACTIONS: {
      AR: "Report Actions",
      FR: "Report Actions",
      TR: "Report Actions",
      ENG: "Report Actions"
    },
    REPORT_ACTION_REASONS: {
      AR: "Report Action Reasons",
      FR: "Report Action Reasons",
      TR: "Report Action Reasons",
      ENG: "Report Action Reasons"
    },
    KHATTABA_QUIZ_STATUS: {
      AR: "status",
      FR: "status",
      TR: "status",
      ENG: "status"
    },
    KHATTABA_QUIZ_STATS: {
      AR: "stats",
      FR: "stats",
      TR: "stats",
      ENG: "stats"
    },
    NO_AI_APPLICATIONS_FOUND: {
      AR: "No results found, users might have valid applications during a different time period",
      FR: "No results found, users might have valid applications during a different time period",
      TR: "No results found, users might have valid applications during a different time period",
      ENG: "No results found, users might have valid applications during a different time period"
    },
    AI_FILTER_USER_ID_DOMINANCE: {
      AR: "UserID search criteria cannot be combined with other search criteria",
      FR: "UserID search criteria cannot be combined with other search criteria",
      TR: "UserID search criteria cannot be combined with other search criteria",
      ENG: "UserID search criteria cannot be combined with other search criteria"
    },
    INVALID_AGE: {
      AR: "Invalid Age",
      FR: "Invalid Age",
      TR: "Invalid Age",
      ENG: "Invalid Age"
    },
    KHATTABA_V3_AI_IS_ALREADY_TURNED_OFF: {
      AR: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required",
      ENG: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required",
      FR: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required",
      TR: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required"
    },
    PLATINUM: {
      AR: "Platinum",
      ENG: "Platinum",
      FR: "Platinum",
      TR: "Platinum"
    },
    SILVER: {
      AR: "Silver",
      ENG: "Silver",
      FR: "Silver",
      TR: "Silver"
    },
    GOLD: {
      AR: "Gold",
      ENG: "Gold",
      FR: "Gold",
      TR: "Gold"
    },
    SILVER_DAYS: {
      AR: "Silver Days",
      ENG: "Silver Days",
      FR: "Silver Days",
      TR: "Silver Days"
    },
    GOLD_DAYS: {
      AR: "Gold Days",
      ENG: "Gold Days",
      FR: "Gold Days",
      TR: "Gold Days"
    },
    PLATINUM_DAYS: {
      AR: "Platinum Days",
      ENG: "Platinum Days",
      FR: "Platinum Days",
      TR: "Platinum Days"
    },
    ADVANCED_DAYS: {
      AR: "Advanced Days",
      ENG: "Advanced Days",
      FR: "Advanced Days",
      TR: "Advanced Days"
    },
    SILVER_HOURS: {
      AR: "Silver Hours",
      ENG: "Silver Hours",
      FR: "Silver Hours",
      TR: "Silver Hours"
    },
    GOLD_HOURS: {
      AR: "Gold Hours",
      ENG: "Gold Hours",
      FR: "Gold Hours",
      TR: "Gold Hours"
    },
    PLATINUM_HOURS: {
      AR: "Platinum Hours",
      ENG: "Platinum Hours",
      FR: "Platinum Hours",
      TR: "Platinum Hours"
    },
    ADVANCED_HOURS: {
      AR: "Advanced Hours",
      ENG: "Advanced Hours",
      FR: "Advanced Hours",
      TR: "Advanced Hours"
    },
    SILVER_MIN: {
      AR: "Silver Min",
      ENG: "Silver Min",
      FR: "Silver Min",
      TR: "Silver Min"
    },
    ADVANCED_MIN: {
      AR: "Advanced Min",
      ENG: "Advanced Min",
      FR: "Advanced Min",
      TR: "Advanced Min"
    },
    GOLD_MIN: {
      AR: "Gold Min",
      ENG: "Gold Min",
      FR: "Gold Min",
      TR: "Gold Min"
    },
    PLATINUM_MIN: {
      AR: "Platinum Min",
      ENG: "Platinum Min",
      FR: "Platinum Min",
      TR: "Platinum Min"
    },
    MAKE_SILVER: {
      AR: "Make Silver",
      ENG: "Make Silver",
      FR: "Make Silver",
      TR: "Make Silver"
    },
    MAKE_GOLD: {
      AR: "Make Gold",
      ENG: "Make Gold",
      FR: "Make Gold",
      TR: "Make Gold"
    },
    MAKE_PLATINUM: {
      AR: "Make Platinum",
      ENG: "Make Platinum",
      FR: "Make Platinum",
      TR: "Make Platinum"
    },
    USER_SILVER_ADDED_SUCCESSFULLY: {
      ENG: "User SILVER added successfully",
      AR: "User SILVER added successfully",
      FR: "User SILVER added successfully",
      TR: "User SILVER added successfully"
    },
    USER_GOLD_ADDED_SUCCESSFULLY: {
      ENG: "User GOLD added successfully",
      AR: "User GOLD added successfully",
      FR: "User GOLD added successfully",
      TR: "User GOLD added successfully"
    },
    USER_PLATINUM_ADDED_SUCCESSFULLY: {
      ENG: "User PLATINUM added successfully",
      AR: "User PLATINUM added successfully",
      FR: "User PLATINUM added successfully",
      TR: "User PLATINUM added successfully"
    },
    USER_ADVANCED_ADDED_SUCCESSFULLY: {
      ENG: "User ADVANCED added successfully",
      AR: "User ADVANCED added successfully",
      FR: "User ADVANCED added successfully",
      TR: "User ADVANCED added successfully"
    },
    APP_VERSION_BELOW_NINE_POINT_FIVE: {
      AR: "User’s app version doesnt support this subscription plan",
      ENG: "User’s app version doesnt support this subscription plan",
      FR: "User’s app version doesnt support this subscription plan",
      TR: "User’s app version doesnt support this subscription plan"
    },
    SUBSCRIPTION_TIME_CONFIRMATION: {
      ENG: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)",
      AR: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)",
      FR: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)",
      TR: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)"
    },
    PROMO_CODE_REWARD_TYPE: {
      ENG: "Reward Type",
      AR: "Reward Type",
      FR: "Reward Type",
      TR: "Reward Type"
    },
    MAKE_ADVANCED: {
      AR: "Make Advanced",
      ENG: "Make Advanced",
      FR: "Make Advanced",
      TR: "Make Advanced"
    },
    ADVANCED_IOS: {
      AR: "Advanced(IOS Refferal)",
      ENG: "Advanced(IOS Refferal)",
      FR: "Advanced(IOS Refferal)",
      TR: "Advanced(IOS Refferal)"
    },
    BUNDLE: {
      AR: "BUNDLE",
      ENG: "BUNDLE",
      FR: "BUNDLE",
      TR: "BUNDLE"
    },
    SILVER_TAG: {
      AR: "SILVER",
      ENG: "SILVER",
      FR: "SILVER",
      TR: "SILVER"
    },
    GOLD_TAG: {
      AR: "GOLD",
      ENG: "GOLD",
      FR: "GOLD",
      TR: "GOLD"
    },
    PLATINUM_TAG: {
      AR: "PLATINUM",
      ENG: "PLATINUM",
      FR: "PLATINUM",
      TR: "PLATINUM"
    },
    ACTIVE_FEATURE_SETS: {
      AR: "Active Feature Sets:",
      ENG: "Active Feature Sets:",
      FR: "Active Feature Sets:",
      TR: "Active Feature Sets:"
    },
    ACTIVE_FEATURES: {
      AR: "Active Features (Consumables):",
      ENG: "Active Features (Consumables):",
      FR: "Active Features (Consumables):",
      TR: "Active Features (Consumables):"
    },
    FEATURE_SET_ACTIVE_FEATURES: {
      AR: "Features Active via Paid Feature Sets:",
      ENG: "Features Active via Paid Feature Sets:",
      FR: "Features Active via Paid Feature Sets:",
      TR: "Features Active via Paid Feature Sets:"
    },
    CONVERSATION_BADGE: {
      AR: "CONVERSATION",
      ENG: "CONVERSATION",
      FR: "CONVERSATION",
      TR: "CONVERSATION"
    },
    LIKES: {
      AR: "LIKES",
      ENG: "LIKES",
      FR: "LIKES",
      TR: "LIKES"
    },
    CONSUMABLES: {
      AR: "Consumables",
      ENG: "Consumables",
      FR: "Consumables",
      TR: "Consumables"
    },
    OTHER_SUBSCRIPTION_HISTORY_FOR: {
      AR: "Other Subscription History For",
      ENG: "Other Subscription History For",
      FR: "Other Subscription History For",
      TR: "Other Subscription History For"
    },
    TRIAL: {
      AR: "Trial",
      ENG: "Trial",
      FR: "Trial",
      TR: "Trial"
    },
    KHATTABAT_ASSIGN_REAL_USERS: {
      ENG: "Real users",
      AR: "Real users",
      FR: "Real users",
      TR: "Real users"
    },

    KHATTABAT_ASSIGN_TESTER_USERS: {
      ENG: "Tester users",
      AR: "Tester users",
      FR: "Tester users",
      TR: "Tester users"
    },

    KHATTABAT_SHOW_RESULTS: {
      ENG: "Show Results",
      AR: "Show Results",
      FR: "Show Results",
      TR: "Show Results"
    },
    KHATTABAT_SELECTED_MATCHES: {
      ENG: "Selected matches",
      AR: "Selected matches",
      FR: "Selected matches",
      TR: "Selected matches"
    },
    CONFIRM: {
      ENG: "Confirm",
      AR: "Confirm",
      FR: "Confirm",
      TR: "Confirm"
    },
    SILENT_BAN_ABBREVIATION: {
      ENG: "SB",
      AR: "SB",
      FR: "SB",
      TR: "SB"
    },
    SILENT_BANNED: {
      ENG: "Silent Banned",
      AR: "Silent Banned",
      FR: "Silent Banned",
      TR: "Silent Banned"
    }
  },

  get(message) {
    const language = this.language.get();
    return this.LG[message] === undefined ||
      this.LG[message][language] === undefined
      ? message
      : this.LG[message][language];
  },
  getWithExtraData(message, extraData) {
    const language = this.language.get();
    const newMessage =
      !this.LG[message] || this.LG[message][language] === undefined
        ? message
        : this.LG[message][language];
    if (newMessage.indexOf("%EXTRA_DATA%") >= 0) {
      const parsedMessage = newMessage.replace(`%EXTRA_DATA%`, extraData);
      return parsedMessage;
    }
    return newMessage;
  },
  getWithArrayExtraData(message, extraData) {
    const language = this.language.get();
    const newMessage =
      !this.LG[message] || this.LG[message][language] === undefined
        ? message
        : this.LG[message][language];
    let parsedMessage = newMessage;
    for (let i = 0; i < extraData.length; i++) {
      if (newMessage.indexOf(`%EXTRA_DATA_${i}%`) >= 0) {
        parsedMessage = parsedMessage.replace(
          `%EXTRA_DATA_${i}%`,
          extraData[i]
        );
      }
    }
    return parsedMessage;
  }
};

export default i18n;
